require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/453144ec95c31675cae282eeef2ea4a9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_453144ec95c31675cae282eeef2ea4a9'] = function fn_453144ec95c31675cae282eeef2ea4a9(latitude, longitude) {
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('0498152af4b82ab882ef18ee8bbb23c9', latitude, longitude);
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('0498152af4b82ab882ef18ee8bbb23c9', 16);

}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/AddPaymentCardtest/components/11bdcbf1eba38108e73f0838aa580538/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('checkout', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/AddPaymentCardtest/components/8f0f453843c83f3836884ab974a828fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function subsequenceFromEndFromEnd(sequence, at1, at2) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  ___arguments.context.pageData['cardNumber'] = ___arguments.value;
  if (___arguments.value.startsWith('4')) {
    ___arguments.context.pageData['cardBrandLogoUrl'] = 'https://backendlessappcontent.com/6681E397-372B-4BCE-99A2-2E952873D446/96788808-D3EB-4CD3-812E-776A24D5DC6B/files/WhatsApp_Image_2026-09-26_at_4.53.21_PM-removebg-preview.png';
  } else if ((___arguments.value.startsWith('51')) || (___arguments.value.startsWith('52')) || (___arguments.value.startsWith('53')) || (___arguments.value.startsWith('54')) || (___arguments.value.startsWith('55')) || ___arguments.value.slice(0, 4) >= 2221 && ___arguments.value.slice(0, 4) <= 2720) {
    ___arguments.context.pageData['cardBrandLogoUrl'] = 'https://backendlessappcontent.com/6681E397-372B-4BCE-99A2-2E952873D446/96788808-D3EB-4CD3-812E-776A24D5DC6B/files/WhatsApp_Image_2026-09-26_at_4.59.02_PM-removebg-preview.png';
  } else {
    ___arguments.context.pageData['cardBrandLogoUrl'] = '';
  }
  ___arguments.context.pageData['cardMaskedDisplay'] = (String(' ••• •••• •••• ') + String(subsequenceFromEndFromEnd(___arguments.value, 3, 0)));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/AddPaymentCardtest/components/522af108f651cf987bb8a45868386a78/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var text;


  ___arguments.context.pageData['expiryDate'] = ___arguments.value;
  ___arguments.context.pageData['expiryValid'] = true;
  if (___arguments.value.slice(0, 2) > '12' || ___arguments.value.slice(0, 2) < '01') {
    (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('522af108f651cf987bb8a45868386a78', 'Invalid month (01-12)');
    ___arguments.context.pageData['expiryValid'] = false;
  } else {
    (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('522af108f651cf987bb8a45868386a78', '');
  }
  if (___arguments.value.length == 4) {
    if (___arguments.value.slice(2, 3) != '/') {
      (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('522af108f651cf987bb8a45868386a78', 'Use MM/YY');
      ___arguments.context.pageData['expiryValid'] = false;
    } else {
      (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('522af108f651cf987bb8a45868386a78', '');
    }
  }
  if (___arguments.value.length == 5) {
    if (___arguments.value.slice(2, 3) != '/') {
      ___arguments.context.pageData['expiryValid'] = false;
    }
    if (2000 + (Number((___arguments.value.slice(3, 5)))) < (new Date((new Date())).getFullYear())) {
      (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('522af108f651cf987bb8a45868386a78', 'Card expired');
      ___arguments.context.pageData['expiryValid'] = false;
    } else {
      if (2000 + (Number((___arguments.value.slice(3, 5)))) == (new Date((new Date())).getFullYear())) {
        if ((Number((___arguments.value.slice(0, 2)))) < (new Date((new Date())).getMonth() + 1)) {
          (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('522af108f651cf987bb8a45868386a78', 'Card expired');
          ___arguments.context.pageData['expiryValid'] = false;
        }
      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/AddPaymentCardtest/components/5c2dfde8a37834e8f34ceb183e0711c5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('5c2dfde8a37834e8f34ceb183e0711c5', '');
  if (!((/^[0-9]{3,4}$/i).test(___arguments.value))) {
    (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('5c2dfde8a37834e8f34ceb183e0711c5', '3 or 4');
    ___arguments.context.pageData['securityValid'] = false;
  } else {
    ___arguments.context.pageData['securityValid'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/AddPaymentCardtest/components/1c68be5805461e689ba8fdc85d284663/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['cardFormValid'] = false;
  (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('c2a45aade23884f1e848f7d8ffb499d9', '');
  if (!(getObjectProperty(___arguments.context.pageData, 'cardHolderName'))) {
    (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('c2a45aade23884f1e848f7d8ffb499d9', 'Enter name on card');
  }
  (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('8f0f453843c83f3836884ab974a828fc', '');
  if (!(getObjectProperty(___arguments.context.pageData, 'cardNumber'))) {
    (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('8f0f453843c83f3836884ab974a828fc', 'Enter card number');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'cardNumber')).length < 13) {
      (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('8f0f453843c83f3836884ab974a828fc', 'Enter full card number');
    }
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'securityValid'))) {
    (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('5c2dfde8a37834e8f34ceb183e0711c5', 'Enter 3 or 4 digits');
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'expireDate'))) {
    (function (componentUid, errorMessage) { ___arguments.context.getComponentByUid(componentUid).setError = errorMessage })('522af108f651cf987bb8a45868386a78', 'Enter expiry date');
  }
  if ((getObjectProperty(___arguments.context.pageData, 'cardHolderName')) && (getObjectProperty(___arguments.context.pageData, 'cardNumber')).length >= 13 && (getObjectProperty(___arguments.context.pageData, 'expiryDate')).length == 5 && (getObjectProperty(___arguments.context.pageData, 'expiryValid')) && (getObjectProperty(___arguments.context.pageData, 'securityValid'))) {
    ___arguments.context.pageData['cardFormValid'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Cart/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['savedCart'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')))));
  if (getObjectProperty(___arguments.context.appData, 'savedCart')) {
    ___arguments.context.appData['cartItems'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartItems'));
    ___arguments.context.appData['cartCount'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartCount'));
    ___arguments.context.appData['cartTotal'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartTotal'));
    ___arguments.context.appData['currentCartStoreId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'currentCartStoreId'));
    ___arguments.context.appData['cartImage1'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartImage1'));
    ___arguments.context.appData['cartImage2'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartImage2'));
  } else {
    ___arguments.context.appData['cartItems'] = [];
    ___arguments.context.appData['cartCount'] = 0;
    ___arguments.context.appData['cartTotal'] = 0;
    ___arguments.context.appData['currentCartStoreId'] = '';
    ___arguments.context.appData['cartImage1'] = '';
    ___arguments.context.appData['cartImage2'] = '';
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bb28aa581b72512b960c9f18aa59aa98', (getObjectProperty(___arguments.context.appData, 'cartItems')));
  ___arguments.context.pageData['currentStoreId'] = (getObjectProperty(___arguments.context.appData, 'currentCartStoreId'));
  ___arguments.context.pageData['storeResult'] = (await Backendless.Data.of('Stores').find(Backendless.DataQueryBuilder.create().setWhereClause((['storeId = \'',(getObjectProperty(___arguments.context.pageData, 'currentStoreId')),'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['currentStoreName'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storeResult'))[0]), 'storeName'));
  ___arguments.context.pageData['currentStoreLogo'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storeResult'))[0]), 'logo'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Cart/components/9ee866096e68baa819f9fb68e0e88452/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Cart/components/4c580c75e648e5583fa5ecb8b8fa4284/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.appData['selectedProduct'] = ___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8');
  ___arguments.context.appData['cartCount'] = ((getObjectProperty(___arguments.context.appData, 'cartCount')) - 1);
  if ((getObjectProperty(___arguments.context.appData, 'cartCount')) < 0) {
    ___arguments.context.appData['cartCount'] = 0;
  }
  ___arguments.context.appData['cartTotal'] = ((getObjectProperty(___arguments.context.appData, 'cartTotal')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'unitPrice')));
  if ((getObjectProperty(___arguments.context.appData, 'cartTotal')) < 0) {
    ___arguments.context.appData['cartTotal'] = 0;
  }
  ___arguments.context.appData['foundCartItem'] = (await asyncListFind((getObjectProperty(___arguments.context.appData, 'cartItems')), async (item) => {


   return ((getObjectProperty(item, 'productId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedProduct')), 'productId')));
  }));
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'quantity')) > 1) {
    ___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8')['quantity'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'quantity')) - 1);
    ___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8')['totalPrice'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'unitPrice')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'quantity')));
    ___arguments.context.appData['cartItems'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bb28aa581b72512b960c9f18aa59aa98'));
  } else {
    ___arguments.context.appData['cartItems'] = (removeItemInList((getObjectProperty(___arguments.context.appData, 'cartItems')), (getObjectProperty(___arguments.context.appData, 'foundCartItem')), ''));
    ___arguments.context.appData['currentQuantity'] = 0;
  }
  localStorage.setItem((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify(({ [`cartItems`]: (getObjectProperty(___arguments.context.appData, 'cartItems')),[`cartCount`]: (getObjectProperty(___arguments.context.appData, 'cartCount')),[`cartTotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')),[`currentCartStoreId`]: (getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),[`cartImage1`]: (getObjectProperty(___arguments.context.appData, 'cartImage1')),[`cartImage2`]: (getObjectProperty(___arguments.context.appData, 'cartImage2')) })));
  if ((getObjectProperty(___arguments.context.appData, 'cartCount')) == 0) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Cart/components/b3188bf84bf9f258db588658f2187691/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedProduct'] = ___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8');
  ___arguments.context.appData['cartCount'] = ((getObjectProperty(___arguments.context.appData, 'cartCount')) + 1);
  ___arguments.context.appData['cartTotal'] = ((getObjectProperty(___arguments.context.appData, 'cartTotal')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'unitPrice')));
  ___arguments.context.appData['cartImage2'] = (getObjectProperty(___arguments.context.appData, 'cartImage1'));
  ___arguments.context.appData['cartImage1'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedProduct')), 'image'));
  ___arguments.context.appData['newOrderItem'] = ({ [`productId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'productId')),[`productName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'productName')),[`quantity`]: 1,[`unitPrice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'unitPrice')),[`storeId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'storeId')),[`totalPrice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'unitPrice')) });
  ___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8')['quantity'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'quantity')) + 1);
  ___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8')['totalPrice'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'unitPrice')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'quantity')));
  ___arguments.context.appData['cartItems'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bb28aa581b72512b960c9f18aa59aa98'));
  localStorage.setItem((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify(({ [`cartItems`]: (getObjectProperty(___arguments.context.appData, 'cartItems')),[`cartCount`]: (getObjectProperty(___arguments.context.appData, 'cartCount')),[`cartTotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')),[`currentCartStoreId`]: (getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),[`cartImage1`]: (getObjectProperty(___arguments.context.appData, 'cartImage1')),[`cartImage2`]: (getObjectProperty(___arguments.context.appData, 'cartImage2')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Cart/components/1419e3c8bf48a098ad7ab3b8bec8bed8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'quantity'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Cart/components/3911d2f817099f839e7de1987a683928/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'productName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Cart/components/b8593d38dc68c65add5803b8c0a6f3e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'unitPrice')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'quantity'))) + String('.00$'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Cart/components/26486dd9551a4bb6714c40b814cebbf6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30b87658034e14d873f74a98f306a4d8'), 'image'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/Cart/components/8101b0f88a5143d80e98e7a8f206c128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentStoreName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Cart/components/a2aa80788938cf18fb480f8d50c79848/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentStoreLogo'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/Cart/components/e95f8f7f55497bc8eeaf6a488cdc946d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('checkout', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Cart/components/5bb8ebfcbc7feeb8f3c4f1f933fc2b67/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.appData, 'cartTotal')) + String('.00$'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Cart/components/dda8eb1d5de7b018bc18bc8877cbcc08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Cart/components/b3888223653cb9e76e885f080ac8d67e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['storeCarts'] = (await (async function(carts, storeId) {
  	return (Array.isArray(carts) ? carts : []).filter(
  	  cart => cart.currentCartStoreId !== storeId
  	);
  })((getObjectProperty(___arguments.context.appData, 'storeCarts')), (getObjectProperty(___arguments.context.appData, 'currentCartStoreId'))));
  localStorage.setItem((String('storeCarts_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify((getObjectProperty(___arguments.context.appData, 'storeCarts'))));
  localStorage.removeItem((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))));
  ___arguments.context.appData['cartItems'] = [];
  ___arguments.context.appData['cartCount'] = 0;
  ___arguments.context.appData['cartTotal'] = 0;
  ___arguments.context.appData['currentCartStoreId'] = '';
  ___arguments.context.appData['cartImage1'] = '';
  ___arguments.context.appData['cartImage2'] = '';
  ___arguments.context.appData['currentQuantity'] = 0;
  ___arguments.context.appData['fountCartItem'] = null;
  ___arguments.context.appData['newOrderItem'] = null;
  ___arguments.context.appData['selectedProduct'] = null;
  ___arguments.context.appData['savedCart'] = null;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ChangePhone/components/13789e8890ae4068f19ed1388ce802b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['newPhone'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ChangePhone/components/cc866738266809bb2ae853bc4d0db417/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var phoneUser;

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  phoneUser = (await Backendless.UserService.getCurrentUser(false));
  phoneUser['phoneChangeToken'] = (mathRandomInt(100000, 999999));
  phoneUser['pendingPhone'] = (getObjectProperty(___arguments.context.pageData, 'newNumber'));
  await Backendless.UserService.update( new Backendless.User(phoneUser) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DeliveringTo/components/3689475880ce90684d08b10fbcd8f2e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentLocation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentLocation = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('38787e78f3c614682d480a6571526da8', (getObjectProperty(currentLocation, 'lat')), (getObjectProperty(currentLocation, 'lng')));
  ___arguments.context.appData['addressLocationConfirmed'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DeliveringTo/components/73b75cdb15fd6e58a94837a9625a9de8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('SelectLocation', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DeliveringTo/components/25180248bd795df448e8f0cda4c7859a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['AddressHasChange'] = true;
  ___arguments.context.pageData['selectedAddressType'] = 'Home';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('25180248bd795df448e8f0cda4c7859a'))['backgroundColor'] = '#914343';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var buttonStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  buttonStyle = ({ [`backgroundColor`]: '#FFFFFF',[`color`]: '#914343' });
  if ((getObjectProperty(___arguments.context.pageData, 'selectedAddressType')) == 'Home') {
    buttonStyle = ({ [`backgroundColor`]: '#914343',[`color`]: '#FFFFFF' });
  }

  return buttonStyle

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/DeliveringTo/components/4288e118d958a7153c2f4a01f8cedf88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['AddressHasChange'] = true;
  ___arguments.context.pageData['selectedAddressType'] = 'Work';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4288e118d958a7153c2f4a01f8cedf88'))['backgroundColor'] = '#914343';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var buttonStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  buttonStyle = ({ [`backgroundColor`]: '#FFFFFF',[`color`]: '#914343' });
  if ((getObjectProperty(___arguments.context.pageData, 'selectedAddressType')) == 'Work') {
    buttonStyle = ({ [`backgroundColor`]: '#914343',[`color`]: '#FFFFFF' });
  }

  return buttonStyle

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/DeliveringTo/components/962c733807746138d3a3e05aa034c518/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['AddressHasChange'] = true;
  ___arguments.context.pageData['selectedAddressType'] = 'Other';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('962c733807746138d3a3e05aa034c518'))['backgroundColor'] = '#914343';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var buttonStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  buttonStyle = ({ [`backgroundColor`]: '#FFFFFF',[`color`]: '#914343' });
  if ((getObjectProperty(___arguments.context.pageData, 'selectedAddressType')) == 'Other') {
    buttonStyle = ({ [`backgroundColor`]: '#914343',[`color`]: '#FFFFFF' });
  }

  return buttonStyle

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/DeliveringTo/components/9d8b4b7c55b877dff10d948815b4c438/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var existingAddresses, newSavedAddresses, mapCenter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'addressLocationConfirmed')) != true) {
    (function (message) { alert(message) })('Please select Current Location or confrirm Adjust your location using Adjust Location');
    return ;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6da9f73bf5f8f37b8f9807035e53f33c')), 'value')) == '' || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614')), 'value')) == '' || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8')), 'value')) == '' || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce9aca66ca7874b860c89de8899e85ad')), 'value')) == '') {
    (function (message) { alert(message) })('Please fill all required fields*');
  } else {
    if (!(getObjectProperty(___arguments.context.appData, 'editingAddressId'))) {
      existingAddresses = (await Backendless.Data.of('Addresses').find(Backendless.DataQueryBuilder.create().setWhereClause((['street = \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614')), 'value')),'\' AND building = \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8')), 'value')),'\' AND floor = \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce9aca66ca7874b860c89de8899e85ad')), 'value')),'\' AND apartment = \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('002859e898b97a88a5689c383d31ce08')), 'value')),'\' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')),'\''].join(''))).setPageSize(10)));
      mapCenter = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('38787e78f3c614682d480a6571526da8'));
      ___arguments.context.appData['selectedLatitude'] = (getObjectProperty(mapCenter, 'lat'));
      ___arguments.context.appData['selectedLongitude'] = (getObjectProperty(mapCenter, 'lng'));
      if (existingAddresses.length == 0) {
        newSavedAddresses = (await Backendless.Data.of('Addresses').save( ({ [`addressName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6da9f73bf5f8f37b8f9807035e53f33c')), 'value')),[`street`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614')), 'value')),[`building`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8')), 'value')),[`floor`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce9aca66ca7874b860c89de8899e85ad')), 'value')),[`apartment`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('002859e898b97a88a5689c383d31ce08')), 'value')),[`instructions`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a67e5608fab86fdb43c4b11b1868b378')), 'value')),[`addressType`]: (getObjectProperty(___arguments.context.pageData, 'selectedAddressType')),[`latitude`]: (getObjectProperty(___arguments.context.appData, 'selectedLatitude')),[`longitude`]: (getObjectProperty(___arguments.context.appData, 'selectedLongitude')),[`photo1`]: (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1')),[`photo2`]: (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2')),[`photo3`]: (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3')) }) ));
        (function (message) { alert(message) })('Address Saved Successfully');
        if ((getObjectProperty(___arguments.context.appData, 'addressReturnPage')) == 'checkout') {
          ___arguments.context.appData['selectedDeliveryAddress'] = newSavedAddresses;
          ___arguments.context.appData['selectedAddressType'] = (getObjectProperty(newSavedAddresses, 'addressType'));
          ___arguments.context.appData['selectedLatitude'] = (getObjectProperty(newSavedAddresses, 'latitude'));
          ___arguments.context.appData['selectedLongitude'] = (getObjectProperty(newSavedAddresses, 'longitude'));
          ___arguments.context.appData['selectedAddressDetails'] = ([(getObjectProperty(newSavedAddresses, 'addressName')),' - ',(getObjectProperty(newSavedAddresses, 'street')),' - ',(getObjectProperty(newSavedAddresses, 'building')),' - ',(getObjectProperty(newSavedAddresses, 'floor')),' - ',(getObjectProperty(newSavedAddresses, 'apartment'))].join(''));
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('checkout', undefined);
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
        }
        return ;
      } else {
        (function (message) { alert(message) })('address already exists');
      }
    } else {
      if (getObjectProperty(___arguments.context.appData, 'editingAddressId')) {
        await Backendless.Data.of('Addresses').save( (getObjectProperty(___arguments.context.appData, 'editingAddress')) );
        await Backendless.Data.of('Addresses').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.appData, 'editingAddressId')),[`addressName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6da9f73bf5f8f37b8f9807035e53f33c')), 'value')),[`street`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614')), 'value')),[`building`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8')), 'value')),[`floor`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce9aca66ca7874b860c89de8899e85ad')), 'value')),[`apartment`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('002859e898b97a88a5689c383d31ce08')), 'value')),[`instructions`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a67e5608fab86fdb43c4b11b1868b378')), 'value')),[`addressType`]: (getObjectProperty(___arguments.context.pageData, 'selectedAddressType')),[`latitude`]: (getObjectProperty(___arguments.context.appData, 'latitude')),[`longitude`]: (getObjectProperty(___arguments.context.appData, 'longitude')),[`photo1`]: (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1')),[`photo2`]: (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2')),[`photo3`]: (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3')) }) );
        (function (message) { alert(message) })('Address updated successfully');
        ___arguments.context.appData['AddressHasChange'] = false;
        ___arguments.context.appData['editingAddressId'] = '';
        ___arguments.context.appData['editingAddress'] = '';
        if ((getObjectProperty(___arguments.context.appData, 'addressReturnPage')) == 'checkout') {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('checkout', undefined);
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
        }
        return ;
      } else if (existingAddresses.length == 0) {
        await Backendless.Data.of('Addresses').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.appData, 'editingAddressId')),[`addressName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6da9f73bf5f8f37b8f9807035e53f33c')), 'value')),[`street`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614')), 'value')),[`building`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8')), 'value')),[`floor`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce9aca66ca7874b860c89de8899e85ad')), 'value')),[`apartment`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('002859e898b97a88a5689c383d31ce08')), 'value')),[`instructions`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a67e5608fab86fdb43c4b11b1868b378')), 'value')),[`addressType`]: (getObjectProperty(___arguments.context.pageData, 'selectedAddressType')),[`latitude`]: (getObjectProperty(___arguments.context.appData, 'selectedLatitude')),[`longitude`]: (getObjectProperty(___arguments.context.appData, 'selectedLongitude')),[`photo1`]: (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1')),[`photo2`]: (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2')),[`photo3`]: (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3')) }) );
        (function (message) { alert(message) })('Address Saved Successfully');
      }
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (!(getObjectProperty(___arguments.context.appData, 'AddressHasChange')) || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6da9f73bf5f8f37b8f9807035e53f33c')), 'value')) == null || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614')), 'value')) == null || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8')), 'value')) == null || !(getObjectProperty(___arguments.context.appData, 'HasAddressPhoto')));

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/DeliveringTo/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentLocation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentLocation = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('38787e78f3c614682d480a6571526da8', (getObjectProperty(currentLocation, 'lat')), (getObjectProperty(currentLocation, 'lng')));
  if ((getObjectProperty(___arguments.context.appData, 'PhotoDescriptionChanged')) == true) {
    ___arguments.context.appData['AddressHasChange'] = true;
    ___arguments.context.appData['PhotoDescriptionChanged'] = false;
  } else {
    ___arguments.context.appData['AddressHasChange'] = false;
  }
  if (!(getObjectProperty(___arguments.context.appData, 'editingAddressId'))) {
    if (getObjectProperty(___arguments.context.appData, 'DraftAddressPhoto1')) {
      ___arguments.context.appData['HasAddressPhoto'] = true;
    } else {
      ___arguments.context.appData['HasAddressPhoto'] = false;
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6da9f73bf5f8f37b8f9807035e53f33c'))['value'] = (getObjectProperty(___arguments.context.appData, 'DraftAddressName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614'))['value'] = (getObjectProperty(___arguments.context.appData, 'DraftStreet'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8'))['value'] = (getObjectProperty(___arguments.context.appData, 'DraftBuilding'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce9aca66ca7874b860c89de8899e85ad'))['value'] = (getObjectProperty(___arguments.context.appData, 'DraftFloor'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('002859e898b97a88a5689c383d31ce08'))['value'] = (getObjectProperty(___arguments.context.appData, 'DraftApartment'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a67e5608fab86fdb43c4b11b1868b378'))['value'] = (getObjectProperty(___arguments.context.appData, 'DraftInstructions'));
    ___arguments.context.pageData['AddressPhoto1'] = (getObjectProperty(___arguments.context.appData, 'DraftAddressPhoto1'));
    ___arguments.context.pageData['AddressPhoto2'] = (getObjectProperty(___arguments.context.appData, 'DraftAddressPhoto2'));
    ___arguments.context.pageData['AddressPhoto3'] = (getObjectProperty(___arguments.context.appData, 'DraftAddressPhoto3'));
    ___arguments.context.pageData['SelectedAddressType'] = (getObjectProperty(___arguments.context.appData, 'DraftAddressType'));
  }
  if (getObjectProperty(___arguments.context.appData, 'editingAddressId')) {
    ___arguments.context.appData['HasAddressPhoto'] = true;
    ___arguments.context.pageData['selectedAddressType'] = (getObjectProperty(___arguments.context.appData, 'DraftAddressType'));
  }
  if (getObjectProperty(___arguments.context.appData, 'editingAddressId')) {
    ___arguments.context.pageData['selectedAddressType'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'addressType'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d8b4b7c55b877dff10d948815b4c438'))['opacity'] = '0.5';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d8b4b7c55b877dff10d948815b4c438'))['style'] = ({ [`property`]: 'backgroundColor',[`value`]: '#f6823C' });
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6da9f73bf5f8f37b8f9807035e53f33c'))['value'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'addressName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614'))['value'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'street'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8'))['value'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'building'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce9aca66ca7874b860c89de8899e85ad'))['value'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'floor'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('002859e898b97a88a5689c383d31ce08'))['value'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'apartment'));
    ___arguments.context.pageData['AddressPhoto1'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'photo1'));
    ___arguments.context.pageData['AddressPhoto2'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'photo2'));
    ___arguments.context.pageData['AddressPhoto3'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'photo3'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'locationConfirmed')) == true) {
    ___arguments.context.pageData['hasAddressChanges'] = false;
  }
  ___arguments.context.pageData['AddressPhotos'] = [];
  if ((getObjectProperty(___arguments.context.appData, 'DeletePhotoNumber')) == 1) {
    ___arguments.context.pageData['AddressPhoto1'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2'));
    (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo1Description'] = '';
    ___arguments.context.appData['DraftPhoto1Description'] = '';
  } else if ((getObjectProperty(___arguments.context.appData, 'DeletePhotoNumber')) == 2) {
    ___arguments.context.pageData['AddressPhoto2'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3'));
    (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo2Description'] = '';
    ___arguments.context.appData['DraftPhoto2Description'] = '';
    ___arguments.context.pageData['AddressPhoto3'] = '';
    (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo2'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2'));
    (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo3'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3'));
  } else if ((getObjectProperty(___arguments.context.appData, 'DeletePhotoNumber')) == 3) {
    ___arguments.context.pageData['AddressPhoto3'] = '';
    (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo2Description'] = '';
    ___arguments.context.appData['DraftPhoto3Description'] = '';
    (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo3'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3'));
  }
  ___arguments.context.appData['DeletePhotoNumber'] = 0;
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('38787e78f3c614682d480a6571526da8', (getObjectProperty(___arguments.context.appData, 'selectedLatitude')), (getObjectProperty(___arguments.context.appData, 'selectedLongitude')));
  if (getObjectProperty(___arguments.context.appData, 'MapLocationChanged')) {
    ___arguments.context.appData['AddressHasChange'] = true;
    ___arguments.context.appData['MapLocationChanged'] = false;
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/DeliveringTo/components/20084488c32d100779df755898c80614/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['AddressHasChange'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/DeliveringTo/components/14b25f58252864c856f190f5ef0dc5a8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['AddressHasChange'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/DeliveringTo/components/ce9aca66ca7874b860c89de8899e85ad/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['AddressHasChange'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/DeliveringTo/components/002859e898b97a88a5689c383d31ce08/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['hasAddressChanges'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/DeliveringTo/components/a67e5608fab86fdb43c4b11b1868b378/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['hasAddressChanges'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/DeliveringTo/components/66ea2a6d48f2786f7f3890a802080443/bundle.js', [], () => ({
  /* content */
  /* handler:onSelectFiles */
  async ['onSelectFiles'](___arguments) {
      await (async function(limitAddressPhoto, files) {
  	if (!files) {
  	  return true;
  	}
  	
  	const selectedFiles = Array.from(files);
  	
  	if (selectedFiles.length > 3) {
  	  alert("You can upload a maximum of 3 photos.");
  	  return false;
  	}
  	
  	return true;
  })(null, ___arguments.selectedFiles);

  },
  /* handler:onSelectFiles */
  /* handler:onUploadSuccess */
  ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.uploadedFiles.length > 1) {
    ___arguments.context.pageData['AddressPhoto1'] = (___arguments.uploadedFiles[0]);
    ___arguments.context.pageData['AddressPhoto2'] = (___arguments.uploadedFiles[1]);
    ___arguments.context.pageData['AddressPhoto3'] = (___arguments.uploadedFiles[2]);
  } else {
    if (!(getObjectProperty(___arguments.context.pageData, 'AddressPhoto1'))) {
      ___arguments.context.pageData['AddressPhoto1'] = (___arguments.uploadedFiles[(___arguments.uploadedFiles.length - 1)]);
    } else if (!(getObjectProperty(___arguments.context.pageData, 'AddressPhoto2'))) {
      ___arguments.context.pageData['AddressPhoto2'] = (___arguments.uploadedFiles[(___arguments.uploadedFiles.length - 1)]);
    } else if (!(getObjectProperty(___arguments.context.pageData, 'AddressPhoto3'))) {
      ___arguments.context.pageData['AddressPhoto3'] = (___arguments.uploadedFiles[(___arguments.uploadedFiles.length - 1)]);
    }
    if (getObjectProperty(___arguments.context.appData, 'editingAddressId')) {
      (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo1'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1'));
      (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo2'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2'));
      (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo3'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3'));
    }
    ___arguments.context.pageData['AddressPhotos'] = ___arguments.uploadedFiles;
  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('66ea2a6d48f2786f7f3890a802080443');
  ___arguments.context.appData['AddressHasChange'] = true;
  ___arguments.context.appData['HasAddressPhoto'] = true;

  },
  /* handler:onUploadSuccess */
  /* handler:onButtonLabelAssignment */
  ['onButtonLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3')) {
    return '📷 Add Photos (3/3)';
  } else if (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2')) {
    return '📷 Add Photos (2/3)';
  } else if (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1')) {
    return '📷 Add Photos (1/3)';
  }

  return '📷 Add Photos (0/3)'

  },
  /* handler:onButtonLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3')) {
    return ({ [`backgroundColor`]: '#D9DDE3',[`color`]: '#FFFFFF' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/DeliveringTo/components/2b68da48b588e568ba07cc4d5a5805c8/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1')) {
    ___arguments.context.appData['SelectedPhoto'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1'));
    ___arguments.context.appData['SelectedPhotoNumber'] = 1;
    ___arguments.context.appData['DraftAddressName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6da9f73bf5f8f37b8f9807035e53f33c')), 'value'));
    ___arguments.context.appData['DraftStreet'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614')), 'value'));
    ___arguments.context.appData['DraftBuilding'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8')), 'value'));
    ___arguments.context.appData['DraftFloor'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce9aca66ca7874b860c89de8899e85ad')), 'value'));
    ___arguments.context.appData['DraftApartment'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('002859e898b97a88a5689c383d31ce08')), 'value'));
    ___arguments.context.appData['DraftAddressPhoto1'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1'));
    ___arguments.context.appData['DraftAddressPhoto2'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2'));
    ___arguments.context.appData['DraftAddressPhoto3'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3'));
    ___arguments.context.appData['DraftAddressType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedAddressType'));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ReviewPhoto', undefined);
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DeliveringTo/components/348868a88668d5497caa01283f569416/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['SelectedPhoto'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2'));
  ___arguments.context.appData['SelectedPhotoNumber'] = 2;
  ___arguments.context.appData['DraftAddressName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6da9f73bf5f8f37b8f9807035e53f33c')), 'value'));
  ___arguments.context.appData['DraftStreet'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614')), 'value'));
  ___arguments.context.appData['DraftBuilding'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8')), 'value'));
  ___arguments.context.appData['DraftFloor'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce9aca66ca7874b860c89de8899e85ad')), 'value'));
  ___arguments.context.appData['DraftApartment'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('002859e898b97a88a5689c383d31ce08')), 'value'));
  ___arguments.context.appData['DraftAddressPhoto1'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1'));
  ___arguments.context.appData['DraftAddressPhoto2'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2'));
  ___arguments.context.appData['DraftAddressPhoto3'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3'));
  ___arguments.context.appData['DraftAddressType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedAddressType'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ReviewPhoto', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DeliveringTo/components/5dc8b25e279fb6f840c8daaeb818527f/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['SelectedPhoto'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3'));
  ___arguments.context.appData['SelectedPhotoNumber'] = 3;
  ___arguments.context.appData['DraftAddressName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6da9f73bf5f8f37b8f9807035e53f33c')), 'value'));
  ___arguments.context.appData['DraftStreet'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('20084488c32d100779df755898c80614')), 'value'));
  ___arguments.context.appData['DraftBuilding'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14b25f58252864c856f190f5ef0dc5a8')), 'value'));
  ___arguments.context.appData['DraftFloor'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce9aca66ca7874b860c89de8899e85ad')), 'value'));
  ___arguments.context.appData['DraftApartment'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('002859e898b97a88a5689c383d31ce08')), 'value'));
  ___arguments.context.appData['DraftAddressPhoto1'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto1'));
  ___arguments.context.appData['DraftAddressPhoto2'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto2'));
  ___arguments.context.appData['DraftAddressPhoto3'] = (getObjectProperty(___arguments.context.pageData, 'AddressPhoto3'));
  ___arguments.context.appData['DraftAddressType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedAddressType'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ReviewPhoto', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DeliveringTo/components/acbf2fe8f0680d78c2f58f8da61828b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Addresses').remove( (getObjectProperty(___arguments.context.appData, 'editingAddress')) );
  (function (message) { alert(message) })('Address Deleted');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
  ___arguments.context.appData['editingAddress'] = '';
  ___arguments.context.appData['editingAddressId'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DeliveringTo/components/5e45441e43d6d1c2ad4e2b98bbd8f47c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DeliveringTo/components/38787e78f3c614682d480a6571526da8/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('38787e78f3c614682d480a6571526da8', (getObjectProperty(___arguments.context.appData, 'selectedLatitude')), (getObjectProperty(___arguments.context.appData, 'selectedLongitude')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('38787e78f3c614682d480a6571526da8', 16);

  },
  /* handler:onMounted */
  /* handler:onPanChange */
  ['onPanChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedLatitude'] = (getObjectProperty(___arguments.value, 'lat'));
  ___arguments.context.appData['selectedLongitude'] = (getObjectProperty(___arguments.value, 'lng'));

  },
  /* handler:onPanChange */
  /* content */
}))

define('./pages/EnterCode/components/f6650ed6298839e89168dc2883a8e0e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ce28a58509e02980b31158307b893cf')), 'value')) == (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'emailChangeToken'))) {
    (await Backendless.UserService.getCurrentUser(false))['email'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'pendingEmail'));
    (await Backendless.UserService.getCurrentUser(false))['pendingEmail'] = '';
    (await Backendless.UserService.getCurrentUser(false))['emailChangeToken'] = '';
    await Backendless.UserService.update( new Backendless.User((await Backendless.UserService.getCurrentUser(false))) );
    ___arguments.context.appData['emailJustChanged'] = true;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ProfilePage', undefined);
  } else {
    (function (message) { alert(message) })('Invalid Verification Code');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['unreadNotificationCount'] = (await Backendless.Data.of('Notifications').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['recipientId =\'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')),'\' AND isRead = false'].join('')))));
  ___arguments.context.appData['savedCart'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')))));
  if (getObjectProperty(___arguments.context.appData, 'savedCart')) {
    ___arguments.context.appData['cartItems'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartItems'));
    ___arguments.context.appData['cartCount'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartCount'));
    ___arguments.context.appData['cartTotal'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartTotal'));
    ___arguments.context.appData['currentCartStoreId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'currentCartStoreId'));
    ___arguments.context.appData['cartImage1'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartImage1'));
    ___arguments.context.appData['cartImage2'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartImage2'));
  } else {
    ___arguments.context.appData['cartItems'] = [];
    ___arguments.context.appData['cartCount'] = 0;
    ___arguments.context.appData['cartTotal'] = 0;
    ___arguments.context.appData['currentCartStoreId'] = '';
    ___arguments.context.appData['cartImage1'] = '';
    ___arguments.context.appData['cartImage2'] = '';
  }
  ___arguments.context.appData['savedAddresses'] = (await Backendless.Data.of('Addresses').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')),' \''].join(''))).setPageSize(10)));
  ___arguments.context.pageData['locationReady'] = true;
  ___arguments.context.appData['currentGeoLocation'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  ___arguments.context.appData['currentLatitude'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentGeoLocation')), 'lat'));
  ___arguments.context.appData['currentLongitude'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentGeoLocation')), 'lng'));
  ___arguments.context.appData['minDistance'] = 999999;
  ___arguments.context.appData['nearestAddress'] = null;
  var j_list = (getObjectProperty(___arguments.context.appData, 'savedAddresses'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.appData['addressLatitude'] = (getObjectProperty(j, 'latitude'));
    ___arguments.context.appData['addressLongitude'] = (getObjectProperty(j, 'longitude'));
    ___arguments.context.appData['latDifference'] = ((getObjectProperty(___arguments.context.appData, 'currentLatitude')) - (getObjectProperty(___arguments.context.appData, 'addressLatitude')));
    ___arguments.context.appData['lngDifference'] = ((getObjectProperty(___arguments.context.appData, 'currentLongitude')) - (getObjectProperty(___arguments.context.appData, 'addressLongitude')));
    ___arguments.context.appData['distanceScore'] = ((getObjectProperty(___arguments.context.appData, 'latDifference')) * (getObjectProperty(___arguments.context.appData, 'latDifference')) + (getObjectProperty(___arguments.context.appData, 'lngDifference')) * (getObjectProperty(___arguments.context.appData, 'lngDifference')));
    if ((getObjectProperty(___arguments.context.appData, 'distanceScore')) < (getObjectProperty(___arguments.context.appData, 'minDistance'))) {
      ___arguments.context.appData['minDistance'] = (getObjectProperty(___arguments.context.appData, 'distanceScore'));
      ___arguments.context.appData['nearestAddress'] = j;
    }
  }
  ___arguments.context.appData['selectedAddress'] = (getObjectProperty(___arguments.context.appData, 'nearestAddress'));
  ___arguments.context.appData['selectedDeliveryAddress'] = (getObjectProperty(___arguments.context.appData, 'nearestAddress'));
  ___arguments.context.appData['selectedAddressType'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedAddress')), 'addressType'));
  ___arguments.context.appData['selectedAddressDetails'] = ([(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedAddress')), 'addressName')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedAddress')), 'street')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedAddress')), 'building')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedAddress')), 'floor'))].join(''));
  ___arguments.context.appData['selectedLatitude'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedAddress')), 'latitude'));
  ___arguments.context.appData['selectedLongitude'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedAddress')), 'longitude'));
  ___arguments.context.appData['showSelectedMap'] = true;
  ___arguments.context.appData['selectedAddressName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedAddress')), 'addressName'));
  ___arguments.context.appData['selectedDeliveryAddressName'] = (getObjectProperty(___arguments.context.appData, 'selectedAddressName'));
  ___arguments.context.appData['selectedAddressStreet'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedAddress')), 'street'));
  if (!!(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')).length) {
    ___arguments.context.appData['userName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'fullName'));
    ___arguments.context.appData['userInitial'] = ((getObjectProperty(___arguments.context.appData, 'userName')).slice(0, 2));
    ___arguments.context.appData['showProfileIcon'] = false;
    ___arguments.context.appData['showProfileInitial'] = true;
  } else {
    ___arguments.context.appData['showProfileIcon'] = true;
    ___arguments.context.appData['showProfileInitial'] = false;
  }
  ___arguments.context.appData['activeNav'] = 'Home';

  },
  /* handler:onEnter */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'locationReady')) != true ? ['home-location-gate', 'location-loading'] : ((getObjectProperty(___arguments.context.pageData, 'locationReady')) == true && (getObjectProperty(___arguments.context.appData, 'savedAddresses')).length == 0 && !(getObjectProperty(___arguments.context.appData, 'showLocationPopup')) ? ['home-location-gate', 'location-required'] : ['home-location-gate']))

  },
  /* handler:onClassListAssignment */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['locationReady'] = false;
  ___arguments.context.appData['showLocationPopup'] = false;
  ___arguments.context.appData['selectedDeliveryAddressName'] = 'Current Location ▼';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/Home/components/6e68b9176bbcc71241f297a8ce14a128/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63dd5c086604d4ddf9cf62786f98f628'))['display'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/74585e1834f8fc788fffb928d9b80801/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['showLocationPopup'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('706c8c28dd413628cb790a9e3748b4f8'))['display'] = true;

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddressName')) {
    return (getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddressName'));
  } else {
    return 'Current Location ▼';
  }

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Home/components/f28778e865b19bbbf6288af581082d24/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('SearchPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/46b837e872287a48479da0c37fbf4cd2/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('46b837e872287a48479da0c37fbf4cd2', 33.8938, 35.05018);
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('46b837e872287a48479da0c37fbf4cd2', 16);

  },
  /* handler:onMounted */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      return ({ [`opacity`]: 0 })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Home/components/76b8f19c7048f0a1173898b87c0883d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Notifications', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/6168e237744927280a18e51c837a5ed8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'unreadNotificationCount'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'unreadNotificationCount')) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/2abeec06cfd9a7371d58eddc42a161c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(carts) {
	const count = (Array.isArray(carts) ? carts : []).filter(
	  cart => cart.currentCartStoreId && Number(cart.cartCount) > 0
	).length;
	
	return count > 0 ? String(count) : "";
})((getObjectProperty(___arguments.context.appData, 'storeCarts'))))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(carts) {
	return (Array.isArray(carts) ? carts : []).some(
	  cart => cart.currentCartStoreId && Number(cart.cartCount) > 0
	);
})((getObjectProperty(___arguments.context.appData, 'storeCarts'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/548b2e587348b8b8c3c8d988ece2f281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await (async function(carts) {
  	return (Array.isArray(carts) ? carts : []).some(
  	  cart => cart.currentCartStoreId && Number(cart.cartCount) > 0
  	);
  })((getObjectProperty(___arguments.context.appData, 'storeCarts'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Cart', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Login/components/0ff809f8b3b83243eee8c89c825822b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.login( (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6f085208ce3d4f0a665838982c78e6d8')), 'value')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f236c07841fccba8f57587b35828e6c9')), 'value')), true  ));
    await (async function(userId) {
    	if (
    	  window.location.origin !== "https://www.csg-lb.com" ||
    	  !userId
    	) {
    	  return;
    	}
    	
    	window.OneSignalDeferred = window.OneSignalDeferred || [];
    	
    	return new Promise(function(resolve) {
    	  const timeout = setTimeout(function() {
    	    alert("Push check: OneSignal did not finish within 20 seconds.");
    	    resolve();
    	  }, 20000);
    	
    	  window.OneSignalDeferred.push(async function(OneSignal) {
    	    try {
    	      await OneSignal.login(String(userId));
    	
    	      alert(
    	        "Account ID: " + String(userId) +
    	        "\nOneSignal External ID: " +
    	          String(OneSignal.User.externalId) +
    	        "\nPermission: " +
    	          String(OneSignal.Notifications.permission) +
    	        "\nSubscribed: " +
    	          String(OneSignal.User.PushSubscription.optedIn) +
    	        "\nSubscription ID: " +
    	          String(OneSignal.User.PushSubscription.id)
    	      );
    	    } catch (error) {
    	      alert(
    	        "Push linking error: " +
    	        (error.message || String(error))
    	      );
    	    } finally {
    	      clearTimeout(timeout);
    	      resolve();
    	    }
    	  });
    	});
    })((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')));
    ___arguments.context.appData['savedCart'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')))));
    if (getObjectProperty(___arguments.context.appData, 'savedCart')) {
      ___arguments.context.appData['cartItems'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartItems'));
      ___arguments.context.appData['cartCount'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartCount'));
      ___arguments.context.appData['cartTotal'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartTotal'));
      ___arguments.context.appData['currentCartStoreId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'currentCartStoreId'));
      ___arguments.context.appData['cartImage1'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartImage1'));
      ___arguments.context.appData['cartImage2'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartImage2'));
    } else {
      ___arguments.context.appData['cartItems'] = [];
      ___arguments.context.appData['cartCount'] = 0;
      ___arguments.context.appData['cartTotal'] = 0;
      ___arguments.context.appData['currentCartStoreId'] = '';
      ___arguments.context.appData['cartImage1'] = '';
      ___arguments.context.appData['cartImage2'] = '';
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Login/components/0de6889840ed77f74ae85a73a27865b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('SignUp', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Login/components/9eb2508837ab06f80ca1e618a2284614/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  await socialLogin('googleplus', null, null, null, 'Home', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Login/components/f1c3461806e9c9ad4ae887ab05da249d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('PasswordRecovery', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Login/components/f236c07841fccba8f57587b35828e6c9/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'key')) == 'Enter') {
    try {
      await Backendless.UserService.login( (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6f085208ce3d4f0a665838982c78e6d8')), 'value')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f236c07841fccba8f57587b35828e6c9')), 'value')), true  );
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

    } catch (error) {
      (function (message) { alert(message) })(error);

    }
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/Login/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await (async function() {
  	if (
  	  window.location.origin === "https://www.csg-lb.com" &&
  	  !window.onePushInitStarted
  	) {
  	  window.onePushInitStarted = true;
  	  window.OneSignalDeferred = window.OneSignalDeferred || [];
  	
  	  window.OneSignalDeferred.push(async function (OneSignal) {
  	    try {
  	      await OneSignal.init({
  	        appId: "05808ab8-5662-4931-84b3-178af62d34c7",
  	
  	        serviceWorkerPath:
  	          "api/files/ui-builder/containers/ONE/onesignal/OneSignalSDKWorker.js",
  	
  	        serviceWorkerParam: {
  	          scope: "/api/files/ui-builder/containers/ONE/onesignal/"
  	        },
  	
  	        notifyButton: {
  	          enable: true
  	        }
  	      });
  	    } catch (error) {
  	      window.onePushInitStarted = false;
  	      console.error("OneSignal initialization failed:", error);
  	    }
  	  });
  	}
  })();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Notifications/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var notification, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['notificationUser'] = (await Backendless.UserService.getCurrentUser(false));
  ___arguments.context.pageData['userNotifications'] = (await Backendless.Data.of('Notifications').find(Backendless.DataQueryBuilder.create().setWhereClause((['recipientId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'notificationUser')), 'objectId')),'\''].join(''))).setSortBy(['created DESC']).setPageSize(100)));
  ___arguments.context.pageData['notificationCards'] = [];
  ___arguments.context.pageData['seenOrderIds'] = [];
  var notification_list = (getObjectProperty(___arguments.context.pageData, 'userNotifications'));
  for (var notification_index in notification_list) {
    notification = notification_list[notification_index];
    if (!((getObjectProperty(___arguments.context.pageData, 'seenOrderIds')).includes((getObjectProperty(notification, 'orderId'))))) {
      ___arguments.context.pageData['notificationOrder'] = (await Backendless.Data.of('Orders').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId =\'',(getObjectProperty(notification, 'orderId')),'\''].join(''))).setPageSize(1)));
      if ((getObjectProperty(___arguments.context.pageData, 'notificationOrder')).length > 0) {
        ___arguments.context.pageData['notificationOrderData'] = ((getObjectProperty(___arguments.context.pageData, 'notificationOrder'))[0]);
        notification['storeName'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'notificationOrderData')), 'storeName'));
        notification['orderNumber'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'notificationOrderData')), 'orderNumber'));
      }
      addItemToList((getObjectProperty(___arguments.context.pageData, 'seenOrderIds')), (getObjectProperty(notification, 'orderId')));
      addItemToList((getObjectProperty(___arguments.context.pageData, 'notificationCards')), notification);
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Notifications/components/277c2912c092badf36eff4620b4f3b68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Notifications/components/4b584078d1281e6107181e77d678e939/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'notificationCards'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Notifications/components/68d8f11835c81fb8e2389e6381096528/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2e8005e1548b4286268c548134cdffa'), 'title'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Notifications/components/2effc138d6339d3c41c25ab8b5a3bb3d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2e8005e1548b4286268c548134cdffa'), 'storeName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Notifications/components/06781bd266b8f9485b68b0f44ec8b4ed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2e8005e1548b4286268c548134cdffa'), 'orderNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Notifications/components/b2e8005e1548b4286268c548134cdffa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.dataModel['isRead'] = true;
  await Backendless.Data.of('Notifications').save( ({ [`objectId`]: (getObjectProperty(___arguments.context.dataModel, 'objectId')),[`isRead`]: true }) );
  ___arguments.context.appData['unreadNotificationCount'] = (await Backendless.Data.of('Notifications').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['recipienId  = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')),'\' AND isRead = false'].join('')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Notifications/components/93df9df3fd782338aff1178c2ea90b78/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2e8005e1548b4286268c548134cdffa'), 'isRead')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Notifications/components/ef882778ea289dc8aa290e488dc45f08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Notifications').bulkUpdate( (['recipientId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')),'\' AND isRead = false'].join('')), ({ [`isRead`]: true }) );
  ___arguments.context.appData['unreadNotificationCount'] = 0;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/OrdersPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.appData['activeNav'] = 'Orders';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/OrdersPage/components/7a5848ed7a1819d7bca81fd870ff64d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/PasswordRecovery/components/4641c8cb6f0597610bb5b1fce8828044/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.UserService.restorePassword((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'emailInput')));
  (function (message) { alert(message) })('Check your email for new password');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', ({ [`propName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'emailInput')) }));

  },
  /* handler:onClick *//* content */
}));

define('./pages/PasswordRecovery/components/bccf8efc4da1bc78120daa098c88eb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ProfilePage/components/7d4891b8dc78571899d88531aaa3c8a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ProfilePage/components/3198b9d57a05284d4ae80d162bdecfa8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('PasswordRecovery', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ProfilePage/components/11eae581b76aeaa483e899689275ecb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  localStorage.setItem((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify(({ [`cartItems`]: (getObjectProperty(___arguments.context.appData, 'cartItems')),[`cartCount`]: (getObjectProperty(___arguments.context.appData, 'cartCount')),[`cartTotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')),[`currentCartStoreId`]: (getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),[`cartImage1`]: (getObjectProperty(___arguments.context.appData, 'cartImage1')),[`cartImage2`]: (getObjectProperty(___arguments.context.appData, 'cartImage2')) })));
  await Backendless.UserService.logout();
  await (async function() {
  	if (window.location.origin === "https://www.csg-lb.com") {
  	  window.OneSignalDeferred = window.OneSignalDeferred || [];
  	
  	  window.OneSignalDeferred.push(async function (OneSignal) {
  	    try {
  	      await OneSignal.logout();
  	    } catch (error) {
  	      console.error("OneSignal logout failed:", error);
  	    }
  	  });
  	}
  })();
  ___arguments.context.appData['cartItems'] = [];
  ___arguments.context.appData['cartCount'] = 0;
  ___arguments.context.appData['cartTotal'] = 0;
  ___arguments.context.appData['currentCartStoreId'] = '';
  ___arguments.context.appData['cartImage1'] = '';
  ___arguments.context.appData['cartImage2'] = '';
  ___arguments.context.appData['currentQuantity'] = 0;
  ___arguments.context.appData['fountCartItem'] = null;
  ___arguments.context.appData['newOrderItem'] = null;
  ___arguments.context.appData['selectedProduct'] = null;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ProfilePage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0a188e482758a2be828823033768cc44'))['value'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'fullName'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a6621c8ced87c29de68d5c8ccd8a098'))['value'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('50a1904827988d8c62689e1899983438'))['value'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'phoneNmber'));
  if ((getObjectProperty(___arguments.context.appData, 'emailJustChanged')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd786bf2b67810b70fe6b6eafdffce11'))['disabled'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd786bf2b67810b70fe6b6eafdffce11'))['disabled'] = true;
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/ProfilePage/components/0a188e482758a2be828823033768cc44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value != (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'fullName'))) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd786bf2b67810b70fe6b6eafdffce11'))['disabled'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd786bf2b67810b70fe6b6eafdffce11'))['disabled'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/ProfilePage/components/cd786bf2b67810b70fe6b6eafdffce11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (await Backendless.UserService.getCurrentUser(false))['fullName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0a188e482758a2be828823033768cc44')), 'value'));
  (function (message) { alert(message) })('Profile Updated Successfully');
  ___arguments.context.appData['emailJustChanged'] = false;
  await Backendless.UserService.update( new Backendless.User((await Backendless.UserService.getCurrentUser(false))) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ProfilePage/components/00b838b8a74691588db8af39fb28a4a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('changeEmail', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ProfilePage/components/2927b0b873482cb15708a4b4aeb85c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ChangePhone', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ProfilePage/components/2e44d6ac0808efd6b40137b86ac8675f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('AddPaymentCardtest', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ProfilePage/components/6268e557cd58a4d10e02abd677682fb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showDeleteConfirm'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ProfilePage/components/71f84d082239c06817a50908fdc82a43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showDeleteConfirm'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/ProfilePage/components/af4fc1c235a8b8b81ae41fcab978ef78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showDeleteConfirm'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ProfilePage/components/38eec9382db7edc88cd8d732ae58a3f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.Request.delete(`${Backendless.appPath}/services/AccountDeleteService/deleteMyAccount`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ReviewPhoto/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'editingAddressId')) {
    if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8'))['value'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'photo1Description'));
    } else if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 2) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8'))['value'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'photo2Description'));
    } else if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 3) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8'))['value'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'editingAddress')), 'photo3Description'));
    }
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8'))['value'] = (getObjectProperty(___arguments.context.appData, 'DraftPhoto1Description'));
    } else if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 2) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8'))['value'] = (getObjectProperty(___arguments.context.appData, 'DraftPhoto2Description'));
    } else if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 3) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8'))['value'] = (getObjectProperty(___arguments.context.appData, 'DraftPhoto3Description'));
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/ReviewPhoto/components/86af9e7334d8918fbbf88ce55c9f0844/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'SelectedPhoto'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/ReviewPhoto/components/4e58dae80698514ab6fb6a3b1e471348/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 1) {
    ___arguments.context.appData['DeletePhotoNumber'] = 1;
  } else if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 2) {
    ___arguments.context.appData['DeletePhotoNumber'] = 2;
  } else if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 3) {
    ___arguments.context.appData['DeletePhotoNumber'] = 3;
  }
  ___arguments.context.appData['AddressHasChange'] = true;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DeliveringTo', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ReviewPhoto/components/5f3de9b9d1b9630851381838fbe489f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ReviewPhoto/components/5c984f3fd916dec643b86dd854e7c5d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'editingAddressId')) {
    if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 1) {
      (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo1Description'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8')), 'value'));
      (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo1'] = (getObjectProperty(___arguments.context.appData, 'DraftAddressPhoto1'));
    } else if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 2) {
      (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo2Description'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8')), 'value'));
      (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo2'] = (getObjectProperty(___arguments.context.appData, 'DraftAddressPhoto2'));
    } else if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 3) {
      (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo3Description'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8')), 'value'));
      (getObjectProperty(___arguments.context.appData, 'editingAddress'))['photo3'] = (getObjectProperty(___arguments.context.appData, 'DraftAddressPhoto1'));
    }
    await Backendless.Data.of('Addresses').save( (getObjectProperty(___arguments.context.appData, 'editingAddress')) );
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 1) {
      ___arguments.context.appData['DraftPhoto1Description'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8')), 'value'));
    } else if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 2) {
      ___arguments.context.appData['DraftPhoto2Description'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8')), 'value'));
    } else if ((getObjectProperty(___arguments.context.appData, 'SelectedPhotoNumber')) == 3) {
      ___arguments.context.appData['DraftPhoto3Description'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c28ac78810d830854cf6cd8aae709b8')), 'value'));
    }
  }
  ___arguments.context.appData['PhotoDescriptionChanged'] = true;
  (function (message) { alert(message) })('Description saved');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DeliveringTo', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SearchPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var recentSearchResults;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showSearchPopup'] = true;
  recentSearchResults = (await Backendless.Data.of('RecentSearches').find(Backendless.DataQueryBuilder.create().setWhereClause((['userId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')),' \''].join(''))).setSortBy('created DESC').setPageSize(10)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('938f6c6832b86a98b781e998677839a1', (recentSearchResults.map(item => item['searchText'])));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/SearchPage/components/19d1519c43eb5d18ff88f7083bf8cf58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SearchPage/components/01187eb8b448f34820e8ac762328d42d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showSearchPopup'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/SearchPage/components/93e94198960150c8b6685528ef08bae5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['searchText'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SearchPage/components/e51849686c09a524ac394d387308b778/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'searchText'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['searchText'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var recentSearchObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.keyCode == 13) {
    ___arguments.context.pageData['searchText'] = (getObjectProperty(___arguments.component, 'value'));
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('938f6c6832b86a98b781e998677839a1')).length >= 10) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('938f6c6832b86a98b781e998677839a1')), (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('938f6c6832b86a98b781e998677839a1'))[0]), '');
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('938f6c6832b86a98b781e998677839a1', (await (async function(items, text) {
    	const word = String(text ?? "").trim();
    	const list = Array.isArray(items) ? [...items] : [];
    	
    	if (!word) return list;
    	
    	return [...list, word].slice(-10);
    })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('938f6c6832b86a98b781e998677839a1')), (getObjectProperty(___arguments.context.pageData, 'searchText')))));
    recentSearchObject = ({ [`propName`]: undefined });
    recentSearchObject['searchText'] = (getObjectProperty(___arguments.context.pageData, 'searchText'));
    recentSearchObject['userId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'));
    recentSearchObject['searchTextNormalized'] = (getObjectProperty(___arguments.context.pageData, 'searchText'));
    await Backendless.Data.of('RecentSearches').save( recentSearchObject );
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/SearchPage/components/acb89dc8a248fbf88ce6365a22b86528/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['searchText'] = ___arguments.context.getComponentDataStoreByUid('7c6495685f88a5ad935321d308d88948');

  },
  /* handler:onClick */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var deletedSearchResults;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('938f6c6832b86a98b781e998677839a1', (removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('938f6c6832b86a98b781e998677839a1')), ___arguments.context.getComponentDataStoreByUid('7c6495685f88a5ad935321d308d88948'), '')));
  deletedSearchResults = (await Backendless.Data.of('RecentSearches').find(Backendless.DataQueryBuilder.create().setWhereClause((['searchText = \'',___arguments.context.getComponentDataStoreByUid('7c6495685f88a5ad935321d308d88948'),' \''].join(''))).setPageSize(1)));
  await Backendless.Data.of('RecentSearches').remove( (getObjectProperty((deletedSearchResults[0]), 'objectId')) );

  },
  /* handler:onDelete */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('7c6495685f88a5ad935321d308d88948')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/SelectLocation/components/8a8c65d793588068a3496db890e81a58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var mapCenter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  mapCenter = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('f14ebc8a0513a8581e18a2f3531a6f1d'));
  ___arguments.context.appData['selectedLatitude'] = (getObjectProperty(mapCenter, 'lat'));
  ___arguments.context.appData['selectedLongitude'] = (getObjectProperty(mapCenter, 'lng'));
  ___arguments.context.appData['addressLocationConfirmed'] = true;
  ___arguments.context.appData['locationConfirmed'] = true;
  ___arguments.context.appData['addressHasChange'] = true;
  (function (message) { alert(message) })('Your address has been confirmed');
  ___arguments.context.appData['MapLocationChanged'] = true;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DeliveringTo', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SelectLocation/components/24e8b6e847c17f2751687ce8ed0164b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var coords, placeDetails, placeId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  placeId = (getObjectProperty(___arguments.value, 'place_id'));
  placeDetails = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })(placeId, ['geometry']));
  await (async function(placeDetails, pageData) {
  	pageData.searchLat = placeDetails.geometry.location.lat();
  	pageData.searchLng = placeDetails.geometry.location.lng();
  })(placeDetails, ___arguments.context.pageData);
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('f14ebc8a0513a8581e18a2f3531a6f1d', (getObjectProperty(___arguments.context.pageData, 'searchLat')), (getObjectProperty(___arguments.context.pageData, 'searchLng')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/SelectLocation/components/e6f84b88ab085838a6284c6d130d43a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SignUp/components/bd6842388f385be6a058d0e9d8b865c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.register( new Backendless.User({ 'phoneNmber': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7488cfecd2281f0c7ff8eab8883c0dc8')), 'value')),'password': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a36e0d813883c6d96b8d84d2398cca8')), 'value')),'address': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('49c8e31ed0eb4a7d27c3f8883ce84bf6')), 'value')),'fullName': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('524a60e76c18f9782dfe81c1a4c3bbf8')), 'value')),'email': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1d17ebf819bcf2bdfd8887483b19be85')), 'value')),'On Success': undefined }) );
    ;(async () => {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Login', undefined);

    })();

  } catch (error) {
    if ((getObjectProperty(error, 'message')).indexOf('User already exists') !== -1) {
      (function (message) { alert(message) })('This email is already registered');
    } else if ((getObjectProperty(error, 'message')).indexOf('phoneNmber') !== -1) {
      (function (message) { alert(message) })('This phone number is already registered');
    } else {
      (function (message) { alert(message) })((getObjectProperty(error, 'message')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Store/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['isStorePage'] = true;
  ___arguments.context.appData['savedCart'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')))));
  if (getObjectProperty(___arguments.context.appData, 'savedCart')) {
    ___arguments.context.appData['cartItems'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartItems'));
    ___arguments.context.appData['cartCount'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartCount'));
    ___arguments.context.appData['cartTotal'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartTotal'));
    ___arguments.context.appData['currentCartStoreId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'currentCartStoreId'));
    ___arguments.context.appData['cartImage1'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartImage1'));
    ___arguments.context.appData['cartImage2'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'savedCart')), 'cartImage2'));
  }
  ___arguments.context.pageData['storesResult'] = (await Backendless.Data.of('Stores').find(Backendless.DataQueryBuilder.create().setWhereClause('storeId =\'CSG-001\'').setPageSize(1)));
  if (!!(getObjectProperty(___arguments.context.pageData, 'storesResult')).length) {
    ___arguments.context.pageData['storeName'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'storeName'));
    ___arguments.context.pageData['category'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'category'));
    ___arguments.context.pageData['rating'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'rating'));
    ___arguments.context.pageData['estimatedDeliveryMinutes'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'estimatedDeliveryMinutes'));
    ___arguments.context.appData['estimatedDeliveryMinutes'] = (getObjectProperty(___arguments.context.pageData, 'estimatedDeliveryMinutes'));
    ___arguments.context.pageData['isOpen'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'isOpen'));
    ___arguments.context.pageData['statusOverride'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'statusOverride'));
    ___arguments.context.pageData['isBusy'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'isBusy'));
    ___arguments.context.pageData['openingTime'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'openingTime'));
    ___arguments.context.pageData['closingTime'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'closingTime'));
    ___arguments.context.appData['closingTime'] = (getObjectProperty(___arguments.context.pageData, 'closingTime'));
    ___arguments.context.appData['openingTime'] = (getObjectProperty(___arguments.context.pageData, 'openingTime'));
    ___arguments.context.pageData['currentTime'] = (new Date());
    ___arguments.context.pageData['currentHour'] = (new Date((getObjectProperty(___arguments.context.pageData, 'currentTime'))).getHours());
    ___arguments.context.pageData['currentMinute'] = (new Date((getObjectProperty(___arguments.context.pageData, 'currentTime'))).getMinutes());
    ___arguments.context.pageData['openingHour'] = (Number(((getObjectProperty(___arguments.context.pageData, 'openingTime')).slice(0, 2))));
    ___arguments.context.pageData['openingMinute'] = (Number(((getObjectProperty(___arguments.context.pageData, 'openingTime')).slice(3, 5))));
    ___arguments.context.pageData['closingHour'] = (Number(((getObjectProperty(___arguments.context.pageData, 'closingTime')).slice(0, 2))));
    ___arguments.context.pageData['closingMinute'] = (Number(((getObjectProperty(___arguments.context.pageData, 'closingTime')).slice(3, 5))));
    ___arguments.context.pageData['currentTotalMinutes'] = ((getObjectProperty(___arguments.context.pageData, 'currentHour')) * 60 + (getObjectProperty(___arguments.context.pageData, 'currentMinute')));
    ___arguments.context.pageData['openingTotalMinutes'] = ((getObjectProperty(___arguments.context.pageData, 'openingHour')) * 60 + (getObjectProperty(___arguments.context.pageData, 'openingMinute')));
    ___arguments.context.pageData['closingTotalMinutes'] = ((getObjectProperty(___arguments.context.pageData, 'closingHour')) * 60 + (getObjectProperty(___arguments.context.pageData, 'closingMinute')));
    ___arguments.context.pageData['isCurrentlyOpen'] = ((getObjectProperty(___arguments.context.pageData, 'currentTotalMinutes')) >= (getObjectProperty(___arguments.context.pageData, 'openingTotalMinutes')) && (getObjectProperty(___arguments.context.pageData, 'currentTotalMinutes')) < (getObjectProperty(___arguments.context.pageData, 'closingTotalMinutes')));
    if ((getObjectProperty(___arguments.context.pageData, 'statusOverride')) == 'Closed') {
      ___arguments.context.pageData['isCurrentlyOpen'] = false;
    } else if ((getObjectProperty(___arguments.context.pageData, 'statusOverride')) == 'Open') {
      ___arguments.context.pageData['isCurrentlyOpen'] = true;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'statusOverride')) != 'Automatic') {
      ___arguments.context.pageData['isCurrentlyOpen'] = (getObjectProperty(___arguments.context.pageData, 'isOpen'));
    } else {
      ___arguments.context.pageData['isCurrentlyOpen'] = ((getObjectProperty(___arguments.context.pageData, 'currentTotalMinutes')) >= (getObjectProperty(___arguments.context.pageData, 'openingTotalMinutes')) && (getObjectProperty(___arguments.context.pageData, 'currentTotalMinutes')) < (getObjectProperty(___arguments.context.pageData, 'closingTotalMinutes')));
    }
  }
  ___arguments.context.pageData['storeRatingsResult'] = (await Backendless.Data.of('StoreRatings').find(Backendless.DataQueryBuilder.create().setWhereClause('storeId =\'CSG-001\'').setPageSize(100)));
  ___arguments.context.pageData['existingUserRating'] = (await Backendless.Data.of('StoreRatings').find(Backendless.DataQueryBuilder.create().setWhereClause((['storeId = \'CSG-001\' AND userId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100)));
  if (!!(getObjectProperty(___arguments.context.pageData, 'existingUserRating')).length) {
    ___arguments.context.pageData['originalRating'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'existingUserRating'))[0]), 'rating'));
    ___arguments.context.pageData['selectedRating'] = (getObjectProperty(___arguments.context.pageData, 'originalRating'));
  }
  ___arguments.context.pageData['testStoreObjectId'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'objectId'));
  ___arguments.context.pageData['ratingCount'] = ((getObjectProperty(___arguments.context.pageData, 'storeRatingsResult')).length);
  ___arguments.context.pageData['ratingSum'] = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'storeRatingsResult'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData['ratingSum'] = ((getObjectProperty(___arguments.context.pageData, 'ratingSum')) + (getObjectProperty(j, 'rating')));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'ratingCount')) > 0) {
    ___arguments.context.pageData['ratingAverage'] = (roundDecimals(((getObjectProperty(___arguments.context.pageData, 'ratingSum')) / (getObjectProperty(___arguments.context.pageData, 'ratingCount'))),1));
    await Backendless.Data.of('Stores').save( ({ [`objectId`]: (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'storesResult'))[0]), 'objectId')),[`rating`]: (getObjectProperty(___arguments.context.pageData, 'ratingAverage')),[`ratingCount`]: (getObjectProperty(___arguments.context.pageData, 'ratingCount')) }) );
  }
  ___arguments.context.appData['activeNav'] = 'Store';
  ___arguments.context.appData['storeCategory'] = 'Services';
  ___arguments.context.pageData['productsResult'] = (await Backendless.Data.of('Products').find(Backendless.DataQueryBuilder.create().setPageSize(10)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('80d81a74e8e8288ca65854182f38f168', (getObjectProperty(___arguments.context.pageData, 'productsResult')));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
      ___arguments.context.appData['isStorePage'] = false;

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/Store/components/d8f8cf9c322870b80e689f9a2016d8e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Store/components/f1880f6f07af6faad8182a216e91c1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('StoreSearch', ({ [`storeId`]: '' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Store/components/f9e8d998fdee23684088ed0fdf282618/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'storeName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Store/components/6f59db1c6e886328fa9bdb7a2662f4ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'category'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Store/components/29aa33c8cc78e9583938518cae9157d8/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.pageData, 'ratingAverage')),'   ( ',(getObjectProperty(___arguments.context.pageData, 'ratingCount')),' )'].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['existingUserRating'] = (await Backendless.Data.of('StoreRatings').find(Backendless.DataQueryBuilder.create().setWhereClause((['storeId = \'CSG-001\' AND userId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(10)));
  if (!!(getObjectProperty(___arguments.context.pageData, 'existingUserRating')).length) {
    ___arguments.context.pageData['originalRating'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'existingUserRating'))[0]), 'rating'));
    ___arguments.context.pageData['slectedRating'] = (getObjectProperty(___arguments.context.pageData, 'existingUserRating'));
  }
  ___arguments.context.pageData['showRatingPopup'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Store/components/52390668c8f6654d3d28e2a84644f2b8/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'estimatedDeliveryMinutes'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Store/components/0cb827b870c9d4383a8371389cd87b08/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'isCurrentlyOpen')) {
    if (getObjectProperty(___arguments.context.pageData, 'isBusy')) {
      return 'Busy';
    }
    return 'Open';
  }
  return 'Closed';

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'isCurrentlyOpen')) {
    if (getObjectProperty(___arguments.context.pageData, 'isBusy')) {
      return ({ [`color`]: '#C58A24' });
    }
    return ({ [`color`]: '#2E7D32' });
  }

  return ({ [`color`]: '#914343' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Store/components/8508a21cde58a008c8a8423828c84ea9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedRating'] = 1;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectedRating')) >= 1) {
    return ({ [`color`]: '#914343' });
  }

  return ({ [`color`]: '#B8B8B8' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Store/components/04086473cc51f45896689a28255614cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedRating'] = 2;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectedRating')) >= 2) {
    return ({ [`color`]: '#914343' });
  }

  return ({ [`color`]: '#B8B8B8' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Store/components/7445c757df688ed7b0f8424cb93807dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedRating'] = 3;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectedRating')) >= 3) {
    return ({ [`color`]: '#914343' });
  }

  return ({ [`color`]: '#B8B8B8' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Store/components/50a16f25eddce8882a71e4182168ce08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedRating'] = 4;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectedRating')) >= 4) {
    return ({ [`color`]: '#914343' });
  }

  return ({ [`color`]: '#B8B8B8' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Store/components/1fb886e341d8bbcf1708cdfb48232678/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedRating'] = 5;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectedRating')) >= 5) {
    return ({ [`color`]: '#914343' });
  }

  return ({ [`color`]: '#B8B8B8' })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Store/components/12ecfb781a18aa189b28b6ca94687dc8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'showRatingPopup'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Store/components/fd2a8e78607842581b25406a852b3178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['showRatingPopup'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Store/components/d088e098aa567ae8f018e968a3f80f16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showRatingPopup'] = true;
  ___arguments.context.pageData['existingUserRating'] = (await Backendless.Data.of('StoreRatings').find(Backendless.DataQueryBuilder.create().setWhereClause((['storeId = \'CSG-001\' AND userId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(10)));
  if (!!(getObjectProperty(___arguments.context.pageData, 'existingUserRating')).length) {
    ((getObjectProperty(___arguments.context.pageData, 'existingUserRating'))[0])['rating'] = (getObjectProperty(___arguments.context.pageData, 'selectedRating'));
    await Backendless.Data.of('StoreRatings').save( ((getObjectProperty(___arguments.context.pageData, 'existingUserRating'))[0]) );
  } else {
    await Backendless.Data.of('StoreRatings').save( ({ [`storeId`]: 'CSG-001',[`rating`]: (getObjectProperty(___arguments.context.pageData, 'selectedRating')),[`userId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')) }) );
  }
  if ((getObjectProperty(___arguments.context.pageData, 'selectedRating')) > 0) {
    ___arguments.context.pageData['showRatingPopup'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedRating')) == (getObjectProperty(___arguments.context.pageData, 'originalRating')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/Store/components/53d8181872abd8244f38e0789c93e428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['storeCategory'] = 'Services';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'storeCategory')) == 'Services') {
    return ({ [`color`]: '#914343' });
  } else {
    return ({ [`color`]: '#8A8A8A' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Store/components/1e35db04300d1bfc6451156df3c8abba/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['storeCategory'] = 'Devices';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'storeCategory')) == 'Devices') {
    return ({ [`color`]: '#914343' });
  } else {
    return ({ [`color`]: '#8A8A8A' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Store/components/8cd4c57be94fa5d4ded813ac5d58fcc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['storeCategory'] = 'Accessories';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'storeCategory')) == 'Accessories') {
    return ({ [`color`]: '#914343' });
  } else {
    return ({ [`color`]: '#8A8A8A' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Store/components/535892c8bac88cf95c783592d0788b61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['storeCategory'] = 'Support';

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'storeCategory')) == 'Support') {
    return ({ [`color`]: '#914343' });
  } else {
    return ({ [`color`]: '#8A8A8A' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Store/components/8a88ab88982888a89fc4e70a18382eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}


  if (!(getObjectProperty(___arguments.context.appData, 'storeCarts'))) {
    ___arguments.context.appData['storeCarts'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('storeCart_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')))));
    if (!(getObjectProperty(___arguments.context.appData, 'storeCarts'))) {
      ___arguments.context.appData['storeCarts'] = [];
    }
  }
  ___arguments.context.appData['cartBeforeAdd'] = ({ [`currentCartStoreId`]: (getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),[`cartItems`]: (getObjectProperty(___arguments.context.appData, 'cartItems')),[`cartCount`]: (getObjectProperty(___arguments.context.appData, 'cartCount')),[`cartTotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')),[`cartImage1`]: (getObjectProperty(___arguments.context.appData, 'cartImage1')),[`cartImage2`]: (getObjectProperty(___arguments.context.appData, 'cartImage2')) });
  ___arguments.context.appData['storeCarts'] = (await (async function(carts, cart) {
  	const result = Array.isArray(carts)
  	  ? JSON.parse(JSON.stringify(carts))
  	  : [];
  	
  	if (!cart?.currentCartStoreId) return result;
  	
  	const index = result.findIndex(
  	  entry => entry.currentCartStoreId === cart.currentCartStoreId
  	);
  	
  	if (!Array.isArray(cart.cartItems) || cart.cartItems.length === 0) {
  	  if (index >= 0) result.splice(index, 1);
  	  return result;
  	}
  	
  	const savedCart = JSON.parse(JSON.stringify(cart));
  	
  	if (index >= 0) {
  	  result[index] = savedCart;
  	} else {
  	  result.push(savedCart);
  	}
  	
  	return result;
  })((getObjectProperty(___arguments.context.appData, 'storeCarts')), (getObjectProperty(___arguments.context.appData, 'cartBeforeAdd'))));
  ___arguments.context.appData['selectedProduct'] = ___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8');
  ___arguments.context.appData['cartToActivate'] = (await (async function(carts, storeId) {
  	const savedCart = (Array.isArray(carts) ? carts : []).find(
  	  cart => cart.currentCartStoreId === storeId
  	);
  	
  	return savedCart
  	  ? JSON.parse(JSON.stringify(savedCart))
  	  : {
  	      currentCartStoreId: storeId,
  	      cartItems: [],
  	      cartCount: 0,
  	      cartTotal: 0,
  	      cartImage1: "",
  	      cartImage2: ""
  	    };
  })((getObjectProperty(___arguments.context.appData, 'storeCarts')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedProduct')), 'storeId'))));
  ___arguments.context.appData['currentCartStoreId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'cartToActivate')), 'currentCartStoreId'));
  ___arguments.context.appData['cartItems'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'cartToActivate')), 'cartItems'));
  ___arguments.context.appData['cartCount'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'cartToActivate')), 'cartCount'));
  ___arguments.context.appData['cartTotal'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'cartToActivate')), 'cartTotal'));
  ___arguments.context.appData['cartImage1'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'cartToActivate')), 'cartImage1'));
  ___arguments.context.appData['cartImage2'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'cartToActivate')), 'cartImage2'));
  ___arguments.context.appData['cartCount'] = ((getObjectProperty(___arguments.context.appData, 'cartCount')) + 1);
  ___arguments.context.appData['cartTotal'] = ((getObjectProperty(___arguments.context.appData, 'cartTotal')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'price')));
  ___arguments.context.appData['cartImage2'] = (getObjectProperty(___arguments.context.appData, 'cartImage1'));
  ___arguments.context.appData['cartImage1'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedProduct')), 'image'));
  ___arguments.context.appData['currentCartStoreId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'storeId'));
  ___arguments.context.appData['newOrderItem'] = ({ [`productId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'productId')),[`productName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'productName')),[`quantity`]: 1,[`unitPrice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'price')),[`storeId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'storeId')),[`totalPrice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'price')),[`image`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'image')) });
  if ((getObjectProperty(___arguments.context.appData, 'cartCount')) <= 1) {
    ___arguments.context.appData['cartItems'] = [(getObjectProperty(___arguments.context.appData, 'newOrderItem'))];
    ___arguments.context.appData['currentQuantity'] = 1;
  } else {
    ___arguments.context.appData['foundCartItem'] = (await asyncListFind((getObjectProperty(___arguments.context.appData, 'cartItems')), async (item) => {


     return ((getObjectProperty(item, 'productName')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'newOrderItem')), 'productName')));
    }));
    if (!(getObjectProperty(___arguments.context.appData, 'foundCartItem'))) {
      ___arguments.context.appData['cartItems'] = (addItemToList((getObjectProperty(___arguments.context.appData, 'cartItems')), (getObjectProperty(___arguments.context.appData, 'newOrderItem'))));
      ___arguments.context.appData['currentQuantity'] = 1;
    } else {
      ___arguments.context.appData['currentQuantity'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'quantity'));
      (getObjectProperty(___arguments.context.appData, 'foundCartItem'))['quantity'] = ((getObjectProperty(___arguments.context.appData, 'currentQuantity')) + 1);
      (getObjectProperty(___arguments.context.appData, 'foundCartItem'))['totalPrice'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'unitPrice'));
      ___arguments.context.appData['foundCartItem'] = ({ [`quantity`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'quantity')),[`productName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'productName')),[`unitPrice`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'unitPrice')),[`storeId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'storeId')),[`totalPrice`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'unitPrice')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'quantity')),[`productId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'productId')),[`image`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'image')) });
      ___arguments.context.appData['cartItems'] = (replaceItemInList((getObjectProperty(___arguments.context.appData, 'cartItems')), (getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'productId'));
      ___arguments.context.appData['currentQuantity'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'quantity'));
    }
  }
  localStorage.setItem((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify(({ [`cartItems`]: (getObjectProperty(___arguments.context.appData, 'cartItems')),[`cartCount`]: (getObjectProperty(___arguments.context.appData, 'cartCount')),[`cartTotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')),[`currentCartStoreId`]: (getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),[`cartImage1`]: (getObjectProperty(___arguments.context.appData, 'cartImage1')),[`cartImage2`]: (getObjectProperty(___arguments.context.appData, 'cartImage2')) })));
  ___arguments.context.appData['cartAfterAdd'] = ({ [`currentCartStoreId`]: (getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),[`cartItems`]: (getObjectProperty(___arguments.context.appData, 'cartItems')),[`cartCount`]: (getObjectProperty(___arguments.context.appData, 'cartCount')),[`cartTotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')),[`cartImage1`]: (getObjectProperty(___arguments.context.appData, 'cartImage1')),[`cartImage2`]: (getObjectProperty(___arguments.context.appData, 'cartImage2')) });
  ___arguments.context.appData['storeCarts'] = (await (async function(carts, cart) {
  	const result = Array.isArray(carts)
  	  ? JSON.parse(JSON.stringify(carts))
  	  : [];
  	
  	if (!cart?.currentCartStoreId) return result;
  	
  	const index = result.findIndex(
  	  entry => entry.currentCartStoreId === cart.currentCartStoreId
  	);
  	
  	if (!Array.isArray(cart.cartItems) || cart.cartItems.length === 0) {
  	  if (index >= 0) result.splice(index, 1);
  	  return result;
  	}
  	
  	const savedCart = JSON.parse(JSON.stringify(cart));
  	
  	if (index >= 0) {
  	  result[index] = savedCart;
  	} else {
  	  result.push(savedCart);
  	}
  	
  	return result;
  })((getObjectProperty(___arguments.context.appData, 'storeCarts')), (getObjectProperty(___arguments.context.appData, 'cartAfterAdd'))));
  localStorage.setItem((String('storeCarts_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify((getObjectProperty(___arguments.context.appData, 'storeCarts'))));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    var stockCartItems, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'productType')) == 'Service') {
    return false;
  }
  stockCartItems = (await asyncListFind((getObjectProperty(___arguments.context.appData, 'cartItems')), async (item) => {


   return ((getObjectProperty(item, 'productId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'productId')));
  }));
  if (stockCartItems) {
    return ((getObjectProperty(stockCartItems, 'quantity')) >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'stockQuantity')));
  } else {
    return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'stockQuantity')) <= 0);
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/Store/components/6afa8d1f85cf70183688d7e8c2288e28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item, rowCardItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  rowCardItem = (await asyncListFind((getObjectProperty(___arguments.context.appData, 'cartItems')), async (item) => {


   return ((getObjectProperty(item, 'productId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'productId')));
  }));
  if (rowCardItem) {
    return (getObjectProperty(rowCardItem, 'quantity'));
  } else {
    return 0;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Store/components/021b33a80a9ee7f300e850931c887757/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.appData['selectedProduct'] = ___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8');
  ___arguments.context.appData['cartCount'] = ((getObjectProperty(___arguments.context.appData, 'cartCount')) - 1);
  if ((getObjectProperty(___arguments.context.appData, 'cartCount')) < 0) {
    ___arguments.context.appData['cartCount'] = 0;
  }
  if ((getObjectProperty(___arguments.context.appData, 'cartCount')) == 0) {
    ___arguments.context.appData['cartImage1'] = '';
    ___arguments.context.appData['cartImage2'] = '';
  }
  ___arguments.context.appData['cartTotal'] = ((getObjectProperty(___arguments.context.appData, 'cartTotal')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'price')));
  if ((getObjectProperty(___arguments.context.appData, 'cartTotal')) < 0) {
    ___arguments.context.appData['cartTotal'] = 0;
  }
  ___arguments.context.appData['newOrderItem'] = ({ [`productId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'productId')),[`productName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'productName')),[`quantity`]: 1,[`unitPrice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'price')),[`storeId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'storeId')),[`totalPrice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'price')),[`image`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'image')) });
  ___arguments.context.appData['foundCartItem'] = (await asyncListFind((getObjectProperty(___arguments.context.appData, 'cartItems')), async (item) => {


   return ((getObjectProperty(item, 'productName')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'newOrderItem')), 'productName')));
  }));
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'quantity')) > 1) {
    ___arguments.context.appData['currentQuantity'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'quantity'));
    (getObjectProperty(___arguments.context.appData, 'foundCartItem'))['quantity'] = ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'quantity')) - 1);
    ___arguments.context.appData['cartItems'] = (replaceItemInList((getObjectProperty(___arguments.context.appData, 'cartItems')), (getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'productId'));
    ___arguments.context.appData['currentQuantity'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCartItem')), 'quantity'));
    ___arguments.context.appData['foundCartItem'] = ({ [`quantity`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCardItem')), 'quantity')),[`productName`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCardItem')), 'productName')),[`unitPrice`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCardItem')), 'unitPrice')),[`storeId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCardItem')), 'storeId')),[`totalPrice`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCardItem')), 'unitPrice')) * (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCardItem')), 'quantity')),[`productId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCardItem')), 'productId')),[`image`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'foundCardItem')), 'image')) });
  } else {
    ___arguments.context.appData['cartItems'] = (removeItemInList((getObjectProperty(___arguments.context.appData, 'cartItems')), (getObjectProperty(___arguments.context.appData, 'foundCartItem')), ''));
    ___arguments.context.appData['currentQuantity'] = 0;
  }
  localStorage.setItem((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify(({ [`cartItems`]: (getObjectProperty(___arguments.context.appData, 'cartItems')),[`cartCount`]: (getObjectProperty(___arguments.context.appData, 'cartCount')),[`cartTotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')),[`currentCartStoreId`]: (getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),[`cartImage1`]: (getObjectProperty(___arguments.context.appData, 'cartImage1')),[`cartImage2`]: (getObjectProperty(___arguments.context.appData, 'cartImage2')) })));
  ___arguments.context.appData['cartAfterAdd'] = ({ [`cartItems`]: (getObjectProperty(___arguments.context.appData, 'cartItems')),[`cartCount`]: (getObjectProperty(___arguments.context.appData, 'cartCount')),[`cartTotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')),[`currentCartStoreId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'storeId')),[`cartImage1`]: (getObjectProperty(___arguments.context.appData, 'cartImage1')),[`cartImage2`]: (getObjectProperty(___arguments.context.appData, 'cartImage2')) });
  ___arguments.context.appData['storeCarts'] = (await (async function(carts, cart) {
  	const result = Array.isArray(carts)
  	  ? JSON.parse(JSON.stringify(carts))
  	  : [];
  	
  	if (!cart || !cart.currentCartStoreId) return result;
  	
  	const index = result.findIndex(
  	  entry => entry.currentCartStoreId === cart.currentCartStoreId
  	);
  	
  	if (
  	  !Array.isArray(cart.cartItems) ||
  	  cart.cartItems.length === 0 ||
  	  Number(cart.cartCount) <= 0
  	) {
  	  if (index >= 0) result.splice(index, 1);
  	  return result;
  	}
  	
  	const savedCart = JSON.parse(JSON.stringify(cart));
  	
  	if (index >= 0) {
  	  result[index] = savedCart;
  	} else {
  	  result.push(savedCart);
  	}
  	
  	return result;
  })((getObjectProperty(___arguments.context.appData, 'storeCarts')), (getObjectProperty(___arguments.context.appData, 'cartAfterAdd'))));
  localStorage.setItem((String('storeCarts_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify((getObjectProperty(___arguments.context.appData, 'storeCarts'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Store/components/ba3cd85c9ed862b8d5cae8042daa7654/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var stockCartItems, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'productType')) == 'Service') {
    return false;
  }
  stockCartItems = (await asyncListFind((getObjectProperty(___arguments.context.appData, 'cartItems')), async (item) => {


   return ((getObjectProperty(item, 'productId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'productId')));
  }));
  if (stockCartItems) {
    return ((getObjectProperty(stockCartItems, 'quantity')) >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'stockQuantity')));
  } else {
    return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('019847883c0bb3446bc897c89abbd2e8'), 'stockQuantity')) <= 0);
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Store/components/3f175318e3ca42a8b138ba77beded218/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'statusOverride')) == 'Closed') {
    return 'This store is temporarily closed.';
  } else if ((getObjectProperty(___arguments.context.pageData, 'isBusy')) == true) {
    return 'This store is busy right now. Please try again later.';
  } else if (!(getObjectProperty(___arguments.context.pageData, 'isCurrentlyOpen'))) {
    return 'This store is currently closed. schedule your order for later.';
  }

  return ''

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Store/components/98f88ad881c735188278f028cc38cc14/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isCurrentlyOpen')) || (getObjectProperty(___arguments.context.pageData, 'isBusy')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Store/components/344f23a8d9f837e2aa9500070fa8c128/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'statusOverride')) == 'Closed' || (getObjectProperty(___arguments.context.pageData, 'isBusy')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Store/components/117d94588868c37ffdfd549ce27b75d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'statusOverride')) == 'Closed') {
    return 'This store is temporarily closed. ';
  }

  return 'This store is busy right now. Please try again later.'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StoreSearch/components/909d79948e488f683678e009a288c4a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/VerifyEmailCode/components/f343852ca65829939138d99825585fc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fb2c31fe948c8b746b6132872ac854d')), 'value')) == (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'emailChangeToken'))) {
    (await Backendless.UserService.getCurrentUser(false))['email'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'pendingEmail'));
    (await Backendless.UserService.getCurrentUser(false))['pendingEmail'] = '';
    (await Backendless.UserService.getCurrentUser(false))['emailChangeToken'] = '';
    await Backendless.UserService.update( new Backendless.User((await Backendless.UserService.getCurrentUser(false))) );
    (function (message) { alert(message) })('Email Updated Successfuly');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('', undefined);
  } else {
    (function (message) { alert(message) })('Invalid Verification Code');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/changeEmail/components/bcc8474ab04af5c8d8f381b8a11f4414/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var userTOUpdate;

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  userTOUpdate = (await Backendless.UserService.getCurrentUser(false));
  userTOUpdate['emailChangeToken'] = (mathRandomInt(100000, 999999));
  userTOUpdate['pendingEmail'] = (getObjectProperty(___arguments.context.pageData, 'newEmail'));
  await Backendless.UserService.update( new Backendless.User(userTOUpdate) );
  await Backendless.Messaging.sendEmail('Email Verfication Code', new Backendless.Bodyparts({ textmessage: (String('Your Verification code is :') + String(getObjectProperty(userTOUpdate, 'emailChangeToken'))) }), ensureArray((listsRepeat((getObjectProperty(___arguments.context.pageData, 'newEmail')), 1))), undefined);
  (function (message) { alert(message) })('Verification code Sent');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('EnterCode', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/changeEmail/components/2f2f237889e8e185d1283f037ed41b88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['newEmail'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/checkout/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.appData['selectedTimeSlot'] = '';
  ___arguments.context.appData['deliveryScheduleType'] = 'now';
  ___arguments.context.pageData['checkoutStoreResults'] = (await Backendless.Data.of('Stores').find(Backendless.DataQueryBuilder.create().setWhereClause((['storeId = \'',(getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),'\''].join(''))).setPageSize(10)));
  if ((getObjectProperty(___arguments.context.pageData, 'checkoutStoreResults')).length > 0) {
    ___arguments.context.pageData['checkoutStore'] = ((getObjectProperty(___arguments.context.pageData, 'checkoutStoreResults'))[0]);
    ___arguments.context.pageData['storeLatitude'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'checkoutStore')), 'latitude'));
    ___arguments.context.pageData['checkoutStatusOverride'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'checkoutStore')), 'statusOverride'));
    ___arguments.context.pageData['checkoutIsBusy'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'checkoutStore')), 'isBusy'));
    ___arguments.context.pageData['checkoutOrderingBlocked'] = ((getObjectProperty(___arguments.context.pageData, 'checkoutStatusOverride')) == 'Closed' || (getObjectProperty(___arguments.context.pageData, 'checkoutIsBusy')));
    ___arguments.context.appData['closingTime'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'checkoutStore')), 'closingTime'));
    ___arguments.context.appData['openingTime'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'checkoutStore')), 'openingTime'));
    ___arguments.context.appData['estimatedDeliveryMinutes'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'checkoutStore')), 'estimatedDeliveryMinutes'));
    ___arguments.context.appData['checkoutStoreLatitude'] = (getObjectProperty(___arguments.context.pageData, 'storeLatitude'));
    ___arguments.context.pageData['storeLongitude'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'checkoutStore')), 'longitude'));
    ___arguments.context.appData['checkoutStoreLongitude'] = (getObjectProperty(___arguments.context.pageData, 'storeLongitude'));
  }
  ___arguments.context.appData['closingHour'] = ((getObjectProperty(___arguments.context.appData, 'closingTime')).slice(0, 2));
  ___arguments.context.appData['closingMinute'] = ((getObjectProperty(___arguments.context.appData, 'closingTime')).slice(3, 5));
  ___arguments.context.appData['closingHourNumber'] = (Number((getObjectProperty(___arguments.context.appData, 'closingHour'))));
  ___arguments.context.appData['closingMinuteNumber'] = (Number((getObjectProperty(___arguments.context.appData, 'closingMinute'))));
  ___arguments.context.appData['closingDateTime'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'closingDateTime')).setHours((getObjectProperty(___arguments.context.appData, 'closingHourNumber')));
  (getObjectProperty(___arguments.context.appData, 'closingDateTime')).setMinutes((getObjectProperty(___arguments.context.appData, 'closingMinuteNumber')));
  ___arguments.context.appData['availableTimeSlots'] = [null];
  if ((new Date()) < (getObjectProperty(___arguments.context.appData, 'closingDateTime'))) {
    ___arguments.context.appData['firstAvailableTime'] = (new Date((new Date()).getTime() + (3600 * 1000)));
    ___arguments.context.appData['firstAvailableMinute'] = (new Date((getObjectProperty(___arguments.context.appData, 'firstAvailableTime'))).getMinutes());
    ___arguments.context.appData['minuteRemainder'] = ((getObjectProperty(___arguments.context.appData, 'firstAvailableMinute')) % 15);
    if ((getObjectProperty(___arguments.context.appData, 'minuteRemainder')) == 0) {
      ___arguments.context.appData['minuteToAdd'] = 0;
    } else {
      ___arguments.context.appData['minuteToAdd'] = (15 - (getObjectProperty(___arguments.context.appData, 'minuteRemainder')));
    }
    ___arguments.context.appData['currentSlotTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'firstAvailableTime')).getTime() + (((getObjectProperty(___arguments.context.appData, 'minuteToAdd')) * 60) * 1000)));
    ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
    addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
    while ((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime')) < (getObjectProperty(___arguments.context.appData, 'closingDateTime'))) {
      ___arguments.context.appData['currentSlotTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
      ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
      addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
    }
  }
  ___arguments.context.appData['openingHour'] = ((getObjectProperty(___arguments.context.appData, 'openingTime')).slice(0, 2));
  ___arguments.context.appData['openingMinute'] = ((getObjectProperty(___arguments.context.appData, 'openingTime')).slice(3, 5));
  ___arguments.context.appData['openingHourNumber'] = (Number((getObjectProperty(___arguments.context.appData, 'openingHour'))));
  ___arguments.context.appData['openingMinuteNumber'] = (Number((getObjectProperty(___arguments.context.appData, 'openingMinute'))));
  ___arguments.context.appData['openingDateTime'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'openingDateTime')).setHours((getObjectProperty(___arguments.context.appData, 'openingHourNumber')));
  (getObjectProperty(___arguments.context.appData, 'openingDateTime')).setMinutes((getObjectProperty(___arguments.context.appData, 'openingMinuteNumber')));
  ___arguments.context.pageData['checkoutScheduleOnly'] = ((getObjectProperty(___arguments.context.pageData, 'checkoutStatusOverride')) == 'Automatic' && !(getObjectProperty(___arguments.context.pageData, 'checkoutOrderingBlocked')) && ((new Date()) < (getObjectProperty(___arguments.context.appData, 'openingDateTime')) || (new Date()) >= (getObjectProperty(___arguments.context.appData, 'closingDateTime'))));
  if ((getObjectProperty(___arguments.context.pageData, 'checkoutScheduleOnly')) || (getObjectProperty(___arguments.context.pageData, 'checkoutOrderingBlocked'))) {
    ___arguments.context.appData['deliveryScheduleType'] = 'later';
  } else {
    ___arguments.context.appData['deliveryScheduleType'] = 'now';
  }
  if (!(getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress'))) {
    ___arguments.context.appData['selectedDeliveryAddress'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('_selectedAddress') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')))));
  }
  if (getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')) {
    ___arguments.context.appData['selectedAddressType'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'addressType'));
    ___arguments.context.appData['selectedAddressDetails'] = ([(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'addressName')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'street')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'building')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'floor'))].join(''));
    ___arguments.context.appData['selectedLatitude'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'latitude'));
    ___arguments.context.appData['selectedLongitude'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'longitude'));
    ___arguments.context.appData['showSelectedMap'] = true;
  } else {
    ___arguments.context.appData['showSelectedMap'] = false;
  }
  ___arguments.context.appData['deliveryChargeUSD'] = null;
  ___arguments.context.appData['deliveryDistanceMeters'] = (await (async function(storeLat, storeLng, addressLat, addressLng) {
  	const origin = {
  	  lat: Number(storeLat),
  	  lng: Number(storeLng)
  	};
  	
  	const destination = {
  	  lat: Number(addressLat),
  	  lng: Number(addressLng)
  	};
  	
  	if (
  	  !Number.isFinite(origin.lat) ||
  	  !Number.isFinite(origin.lng) ||
  	  !Number.isFinite(destination.lat) ||
  	  !Number.isFinite(destination.lng)
  	) {
  	  return `storeLat=${storeLat}, storeLng=${storeLng}, addressLat=${addressLat}, addressLng=${addressLng}`;
  	}
  	
  	return (async () => {
  	  try {
  	    const { Route } = await google.maps.importLibrary('routes');
  	
  	    const { routes } = await Route.computeRoutes({
  	      origin,
  	      destination,
  	      travelMode: 'DRIVING',
  	      fields: ['distanceMeters']
  	    });
  	
  	    return routes?.[0]?.distanceMeters ?? 'NO_ROUTE';
  	  } catch (error) {
  	    console.error('Delivery route error:', error);
  	    return 'ROUTE_ERROR: ' + (error?.message || String(error));
  	  }
  	})();
  })((getObjectProperty(___arguments.context.appData, 'checkoutStoreLatitude')), (getObjectProperty(___arguments.context.appData, 'checkoutStoreLongitude')), (getObjectProperty(___arguments.context.appData, 'selectedLatitude')), (getObjectProperty(___arguments.context.appData, 'selectedLongitude'))));
  if ((getObjectProperty(___arguments.context.appData, 'deliveryDistanceMeters')) != null) {
    ___arguments.context.appData['deliveryChargeUSD'] = 1.5;
    if ((getObjectProperty(___arguments.context.appData, 'deliveryDistanceMeters')) > 3000) {
      ___arguments.context.appData['deliveryChargeUSD'] = (Math.ceil(((getObjectProperty(___arguments.context.appData, 'deliveryDistanceMeters')) - 3000) / 1000) * 0.5 + 1.5);
    }
  }
  if (!(getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod'))) {
    ___arguments.context.appData['selectedPaymentMethod'] = 'cash';
  }
  ___arguments.context.pageData['selectedPaymentLabel'] = 'Cash';
  ___arguments.context.pageData['cashImageUrl'] = 'https://backendlessappcontent.com/6681E397-372B-4BCE-99A2-2E952873D446/96788808-D3EB-4CD3-812E-776A24D5DC6B/files/WhatsApp_Image_2026-09-27_at_5.20.11_PM-removebg-preview.png';
  ___arguments.context.pageData['reviewCartItems'] = (getObjectProperty(___arguments.context.appData, 'cartItems'));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod'))) {
    ___arguments.context.appData['selectedPaymentMethod'] = 'cash';
  }
  ___arguments.context.appData['selectedPaymentLabel'] = 'Cash';
  ___arguments.context.pageData['cashImageUrl'] = 'https://backendlessappcontent.com/6681E397-372B-4BCE-99A2-2E952873D446/96788808-D3EB-4CD3-812E-776A24D5DC6B/files/WhatsApp_Image_2026-09-27_at_5.20.11_PM-removebg-preview.png';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/checkout/components/9504172b8ddd1828057847281dd8394d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.appData['deliveryScheduleType'] = 'now';
  ___arguments.context.appData['deliveryRequestedAt'] = (new Date());
  ___arguments.context.appData['estimatedDeliveryAt'] = (new Date((getObjectProperty(___arguments.context.appData, 'deliveryRequestedAt')).getTime() + (((Number((getObjectProperty(___arguments.context.appData, 'estimatedDeliveryMinutes')))) * 60) * 1000)));
  ___arguments.context.appData['selectedTimeSlot'] = 'Book For Later';
  ___arguments.context.appData['showScheduleSheet'] = false;
  ___arguments.context.appData['selectedScheduleDay'] = '';
  ___arguments.context.appData['selectedScheduleDayLabel'] = '';
  ___arguments.context.appData['availableTimeSlots'] = [null];
  if ((new Date()) < (getObjectProperty(___arguments.context.appData, 'closingDateTime'))) {
    ___arguments.context.appData['firstAvailableTime'] = (new Date((new Date()).getTime() + (3600 * 1000)));
    ___arguments.context.appData['firstAvailableMinute'] = (new Date((getObjectProperty(___arguments.context.appData, 'firstAvailableTime'))).getMinutes());
    ___arguments.context.appData['minuteRemainder'] = ((getObjectProperty(___arguments.context.appData, 'firstAvailableMinute')) % 15);
    if ((getObjectProperty(___arguments.context.appData, 'minuteRemainder')) == 0) {
      ___arguments.context.appData['minuteToAdd'] = 0;
    } else {
      ___arguments.context.appData['minuteToAdd'] = (15 - (getObjectProperty(___arguments.context.appData, 'minuteRemainder')));
    }
    ___arguments.context.appData['currentSlotTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'firstAvailableTime')).getTime() + (((getObjectProperty(___arguments.context.appData, 'minuteToAdd')) * 60) * 1000)));
    ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
    addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
    while ((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime')) < (getObjectProperty(___arguments.context.appData, 'closingDateTime'))) {
      ___arguments.context.appData['currentSlotTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
      ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
      addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
    }
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.appData, 'estimatedDeliveryMinutes')))

  },
  /* handler:onLabelAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var buttonStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'deliveryScheduleType')) == 'now') {
    buttonStyle = ({ [`backgroundColor`]: '#FFFFFF',[`color`]: '#914343' });
  } else {
    buttonStyle = ({ [`backgroundColor`]: '#F8F8F4',[`color`]: '#000000' });
  }

  return buttonStyle

  },
  /* handler:onStyleAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'checkoutOrderingBlocked')) || (getObjectProperty(___arguments.context.pageData, 'checkoutScheduleOnly')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'deliveryScheduleType')) == 'now') {
    return ['delivery-now-button', 'is-selected'];
  } else {
    return ['delivery-now-button'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/checkout/components/9c7e6d3fae5bb16105987d17771956d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['deliveryScheduleType'] = 'later';
  if ((getObjectProperty(___arguments.context.appData, 'selectedScheduleDay')) == '') {
    ___arguments.context.appData['selectedScheduleDay'] = (new Date());
    ___arguments.context.appData['selectedScheduleDay'] = 'today';
  }
  ___arguments.context.appData['showScheduleSheet'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var buttonStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'deliveryScheduleType')) == 'later') {
    buttonStyle = ({ [`backgroundColor`]: '#FFFFFF',[`color`]: '#914343' });
  } else {
    buttonStyle = ({ [`backgroundColor`]: '#F8F8F4',[`color`]: '#000000' });
  }

  return buttonStyle

  },
  /* handler:onStyleAssignment */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'selectedScheduleDay')) == 'today') {
    ___arguments.context.appData['selectedScheduleDayLabel'] = (new Intl.DateTimeFormat('en-US', ({ [`weekday`]: 'long' })).format((new Date())));
  } else if ((getObjectProperty(___arguments.context.appData, 'selectedScheduleDay')) == 'tomorrow') {
    ___arguments.context.appData['selectedScheduleDayLabel'] = (new Intl.DateTimeFormat('en-US', ({ [`weekday`]: 'long' })).format((new Date((new Date()).getTime() + (86400 * 1000)))));
  } else if ((getObjectProperty(___arguments.context.appData, 'selectedScheduleDay')) == 'day2') {
    ___arguments.context.appData['selectedScheduleDayLabel'] = (new Intl.DateTimeFormat('en-US', ({ [`weekday`]: 'long' })).format((new Date((new Date()).getTime() + (172800 * 1000)))));
  } else if ((getObjectProperty(___arguments.context.appData, 'selectedScheduleDay')) == 'day3') {
    ___arguments.context.appData['selectedScheduleDayLabel'] = (new Intl.DateTimeFormat('en-US', ({ [`weekday`]: 'long' })).format((new Date((new Date()).getTime() + (259200 * 1000)))));
  }
  if ((getObjectProperty(___arguments.context.appData, 'selectedTimeSlot')) != '') {
    return (await (async function(scheduleText) {
    	return "Book for later\n" +
    	  String(scheduleText || "").trim().replace(
    	    /^(\S+)\s+(?=\d{1,2}:)/,
    	    "$1\n"
    	  );
    })(([(getObjectProperty(___arguments.context.appData, 'selectedScheduleDayLabel')),'   ',(getObjectProperty(___arguments.context.appData, 'selectedTimeSlot'))].join(''))));
  } else {
    return 'Book For Later';
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'checkoutOrderingBlocked'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'deliveryScheduleType')) == 'later') {
    return ['delivery-later-button', 'is-selected'];
  } else {
    return ['delivery-later-button'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/checkout/components/fcbd686408383d9e6828ab18879de997/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return (['','    ',((new Date()).toDateString())].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.appData['availableTimeSlots'] = [null];
  if ((new Date()) < (getObjectProperty(___arguments.context.appData, 'closingDateTime'))) {
    ___arguments.context.appData['selectedScheduleDay'] = 'today';
    ___arguments.context.appData['selectedScheduleDate'] = (new Date());
    ___arguments.context.appData['firstAvailableTime'] = (new Date((new Date()).getTime() + (3600 * 1000)));
    ___arguments.context.appData['firstAvailableMinute'] = (new Date((getObjectProperty(___arguments.context.appData, 'firstAvailableTime'))).getMinutes());
    ___arguments.context.appData['minuteRemainder'] = ((getObjectProperty(___arguments.context.appData, 'firstAvailableMinute')) % 15);
    if ((getObjectProperty(___arguments.context.appData, 'minuteRemainder')) == 0) {
      ___arguments.context.appData['minuteToAdd'] = 0;
    } else {
      ___arguments.context.appData['minuteToAdd'] = (15 - (getObjectProperty(___arguments.context.appData, 'minuteRemainder')));
    }
    ___arguments.context.appData['currentSlotTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'firstAvailableTime')).getTime() + (((getObjectProperty(___arguments.context.appData, 'minuteToAdd')) * 60) * 1000)));
    ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
    addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
    while ((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime')) < (getObjectProperty(___arguments.context.appData, 'closingDateTime'))) {
      ___arguments.context.appData['currentSlotTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
      ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
      addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
    }
  }
  ___arguments.context.appData['closingHour'] = ((getObjectProperty(___arguments.context.appData, 'closingTime')).slice(0, 2));
  ___arguments.context.appData['closingMinute'] = ((getObjectProperty(___arguments.context.appData, 'closingTime')).slice(3, 5));
  ___arguments.context.appData['closingHourNumber'] = (Number((getObjectProperty(___arguments.context.appData, 'closingHour'))));
  ___arguments.context.appData['closingMinuteNumber'] = (Number((getObjectProperty(___arguments.context.appData, 'closingMinute'))));
  ___arguments.context.appData['closingDateTime'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'closingDateTime')).setHours((getObjectProperty(___arguments.context.appData, 'closingHourNumber')));
  (getObjectProperty(___arguments.context.appData, 'closingDateTime')).setMinutes((getObjectProperty(___arguments.context.appData, 'closingMinuteNumber')));
  ___arguments.context.appData['openingHour'] = ((getObjectProperty(___arguments.context.appData, 'openingTime')).slice(0, 2));
  ___arguments.context.appData['openingMinute'] = ((getObjectProperty(___arguments.context.appData, 'openingTime')).slice(3, 5));
  ___arguments.context.appData['openingHourNumber'] = (Number((getObjectProperty(___arguments.context.appData, 'openingHour'))));
  ___arguments.context.appData['openingMinuteNumber'] = (Number((getObjectProperty(___arguments.context.appData, 'openingMinute'))));
  ___arguments.context.appData['openingDateTime'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'openingDateTime')).setHours((getObjectProperty(___arguments.context.appData, 'openingHourNumber')));
  (getObjectProperty(___arguments.context.appData, 'openingDateTime')).setMinutes((getObjectProperty(___arguments.context.appData, 'openingMinuteNumber')));

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var dayButtonStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'selectedScheduleDay')) == 'today' && (new Date()) < (getObjectProperty(___arguments.context.appData, 'closingDateTime'))) {
    dayButtonStyle = ({ [`backgroundColor`]: '#FFFFFF',[`color`]: '#914343' });
  } else {
    dayButtonStyle = ({ [`backgroundColor`]: '#914343',[`color`]: '#000000' });
  }

  return dayButtonStyle

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/checkout/components/a1d84cca4a67b7cc3ad8c7b8f9c8be12/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return (String('  ') + String((new Date((new Date()).getTime() + (86400 * 1000))).toDateString()))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.appData['selectedScheduleDay'] = 'tomorrow';
  ___arguments.context.appData['selectedScheduleDate'] = (new Date());
  (getObjectProperty(___arguments.context.appData, 'selectedScheduleDate')).setDate(((new Date((getObjectProperty(___arguments.context.appData, 'selectedScheduleDate'))).getDate()) + 1));
  ___arguments.context.appData['currentSlotTime'] = (getObjectProperty(___arguments.context.appData, 'openingDateTime'));
  ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
  ___arguments.context.appData['availableTimeSlots'] = [null];
  addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
  while ((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime')) < (getObjectProperty(___arguments.context.appData, 'closingDateTime'))) {
    ___arguments.context.appData['currentSlotTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
    ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
    addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var dayButtonStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'selectedScheduleDay')) == 'tomorrow') {
    dayButtonStyle = ({ [`backgroundColor`]: '#FFFFFF',[`color`]: '#914343' });
  } else {
    dayButtonStyle = ({ [`backgroundColor`]: '#914343',[`color`]: '#000000' });
  }

  return dayButtonStyle

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/checkout/components/ff28f5b80eb878984b5830b8e7b85e68/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return (['','  ',((new Date((new Date()).getTime() + (172800 * 1000))).toDateString())].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.appData['selectedScheduleDay'] = 'day2';
  ___arguments.context.appData['currentSlotTime'] = (getObjectProperty(___arguments.context.appData, 'openingDateTime'));
  ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
  ___arguments.context.appData['availableTimeSlots'] = [null];
  addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
  while ((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime')) < (getObjectProperty(___arguments.context.appData, 'closingDateTime'))) {
    ___arguments.context.appData['currentSlotTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
    ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
    addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var dayButtonStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'selectedScheduleDay')) == 'day2') {
    dayButtonStyle = ({ [`backgroundColor`]: '#FFFFFF',[`color`]: '#914343' });
  } else {
    dayButtonStyle = ({ [`backgroundColor`]: '#914343',[`color`]: '#000000' });
  }

  return dayButtonStyle

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/checkout/components/4f083ca8a5688fa860785614d6de4278/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return (String('  ') + String((new Date((new Date()).getTime() + (259200 * 1000))).toDateString()))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.appData['selectedScheduleDay'] = 'day3';
  ___arguments.context.appData['currentSlotTime'] = (getObjectProperty(___arguments.context.appData, 'openingDateTime'));
  ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
  ___arguments.context.appData['availableTimeSlots'] = [null];
  addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
  while ((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime')) < (getObjectProperty(___arguments.context.appData, 'closingDateTime'))) {
    ___arguments.context.appData['currentSlotTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
    ___arguments.context.appData['currentSlotEndTime'] = (new Date((getObjectProperty(___arguments.context.appData, 'currentSlotTime')).getTime() + (900 * 1000)));
    addItemToList((getObjectProperty(___arguments.context.appData, 'availableTimeSlots')), ([(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotTime')))),' - ',(new Intl.DateTimeFormat('en-US', ({ [`hour`]: 'numeric',[`minute`]: '2-digit',[`hour12`]: true })).format((getObjectProperty(___arguments.context.appData, 'currentSlotEndTime'))))].join('')));
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var dayButtonStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'selectedScheduleDay')) == 'day3') {
    dayButtonStyle = ({ [`backgroundColor`]: '#FFFFFF',[`color`]: '#914343' });
  } else {
    dayButtonStyle = ({ [`backgroundColor`]: '#914343',[`color`]: '#000000' });
  }

  return dayButtonStyle

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/checkout/components/a41511ac1618fe483a180a089688a182/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'deliveryScheduleType')) == 'later' && (getObjectProperty(___arguments.context.appData, 'showScheduleSheet')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/checkout/components/ca38b08a167a9588b42828084ef8dfd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/checkout/components/b42875880136f375b2681d8d00a918f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'availableTimeSlots'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/checkout/components/a31854b860c74b7824d1c1f8dba8c1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('5c7c1d082f2c6358c64e2fc49bd8bc63')

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedTimeSlot'] = ___arguments.context.getComponentDataStoreByUid('5c7c1d082f2c6358c64e2fc49bd8bc63');
  ___arguments.context.appData['showScheduleSheet'] = false;
  if ((getObjectProperty(___arguments.context.appData, 'selectedScheduleDay')) == '') {
    ___arguments.context.appData['selectedScheduleDay'] = 'today';
    ___arguments.context.appData['selectedScheduleDate'] = (new Date());
  }
  ___arguments.context.appData['selectedSlotStartText'] = ((getObjectProperty(___arguments.context.appData, 'selectedTimeSlot')).split(',')[0]);
  ___arguments.context.appData['selectedSlotHour'] = (Number(((getObjectProperty(___arguments.context.appData, 'selectedSlotStartText')).split(':')[0])));
  ___arguments.context.appData['selectedSlotMinuteText'] = ((getObjectProperty(___arguments.context.appData, 'selectedSlotStartText')).split(':')[1]);
  ___arguments.context.appData['selectedSlotMinute'] = (Number(((getObjectProperty(___arguments.context.appData, 'selectedSlotMinuteText')).slice(0, 2))));
  ___arguments.context.appData['selectedSlotPeriod'] = ((getObjectProperty(___arguments.context.appData, 'selectedSlotMinuteText')).slice(3, 5));
  if ((getObjectProperty(___arguments.context.appData, 'selectedSlotPeriod')) == 'PM' && (getObjectProperty(___arguments.context.appData, 'selectedSlotHour')) < 12) {
    ___arguments.context.appData['selectedSlotHour'] = ((getObjectProperty(___arguments.context.appData, 'selectedSlotHour')) + 12);
  }
  if ((getObjectProperty(___arguments.context.appData, 'selectedSlotPeriod')) == 'AM' && (getObjectProperty(___arguments.context.appData, 'selectedSlotSlotHour')) == 12) {
    ___arguments.context.appData['selectedSlotHour'] = 0;
  }
  (getObjectProperty(___arguments.context.appData, 'selectedScheduleDate')).setHours((getObjectProperty(___arguments.context.appData, 'selectedSlotHour')));
  (getObjectProperty(___arguments.context.appData, 'selectedScheduleDate')).setMinutes((getObjectProperty(___arguments.context.appData, 'selectedSlotMinute')));
  (getObjectProperty(___arguments.context.appData, 'selectedScheduleDate')).setSeconds(0);
  (getObjectProperty(___arguments.context.appData, 'selectedScheduleDate')).setMilliseconds(0);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var timeButtonStyle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'selectedTimeSlot')) == ___arguments.context.getComponentDataStoreByUid('5c7c1d082f2c6358c64e2fc49bd8bc63')) {
    timeButtonStyle = ({ [`backgroundColor`]: '#914343',[`color`]: '#FFFFFF' });
  } else {
    timeButtonStyle = ({ [`backgroundColor`]: '#FFFFFF',[`color`]: '#914343' });
  }

  return timeButtonStyle

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/checkout/components/355cdf1944bc102860a8be08e209116e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['addressReturnPage'] = 'checkout';
  ___arguments.context.appData['showLocationPopup'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aef8437111c73378af18726797a8c558', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/checkout/components/1238be1958d811253c4fe178a594ce68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'selectedAddressType'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/c45896c9d106df0fb33de85e7d087cf2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'selectedAddressDetails'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/0498152af4b82ab882ef18ee8bbb23c9/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('0498152af4b82ab882ef18ee8bbb23c9', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'latitude')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'longitude')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('0498152af4b82ab882ef18ee8bbb23c9', 13);

  },
  /* handler:onMounted */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'showSelectedMap')) {
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('0498152af4b82ab882ef18ee8bbb23c9', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'latitude')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'longitude')));
    (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('0498152af4b82ab882ef18ee8bbb23c9', 13);
    return ({ [`opacity`]: 1 });
  } else {
    return ({ [`opacity`]: 0 });
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })('map changed');
  if (___arguments.newValue) {
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('0498152af4b82ab882ef18ee8bbb23c9', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'latitude')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'longitude')));
    (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('0498152af4b82ab882ef18ee8bbb23c9', 13);
  }

  },
  /* handler:onVisibilityChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'refreshCheckoutMap')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/checkout/components/bd587fc89ed8df280f28cfa3f4481268/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e918e7cadc091af817086ee8bc789e0c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/checkout/components/8858d0b8d853c7d83e38dea801788b37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e918e7cadc091af817086ee8bc789e0c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/checkout/components/f68771e8306e166c8e5e34c8ac5f0be1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['showScheduleSheet'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/checkout/components/4d020ad57848da185914830d6afbbab1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('AddPaymentCardtest', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/checkout/components/e5b33004ff32b46b51f10611a2bbc131/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.appData['selectedPaymentMethod'] = 'cash';
    ___arguments.context.pageData['selectedPaymentLabel'] = 'Cash';
    ___arguments.context.pageData['cashImageUrl'] = 'https://backendlessappcontent.com/6681E397-372B-4BCE-99A2-2E952873D446/96788808-D3EB-4CD3-812E-776A24D5DC6B/files/WhatsApp_Image_2026-09-27_at_5.20.11_PM-removebg-preview.png';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e918e7cadc091af817086ee8bc789e0c', false);
  } else {
    ___arguments.context.appData['selectedPaymentMethod'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod')) == 'cash')

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/checkout/components/9a28d4288ad8452dc3b89a613daa080d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod')) == 'cash') {
    return 'Cash';
  }

  return ''

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/95389104e7b48838a2a961c3e378e8c1/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'cashImageUrl'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod')) == 'cash')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/checkout/components/6aa8415c67687ec8b978a468cf1488ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Number.parseFloat((getObjectProperty(___arguments.context.appData, 'cartTotal'))).toFixed(2)) + String('$ (USD)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/cac810aba0e8bab84d36bd2eafe888d5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Number.parseFloat((getObjectProperty(___arguments.context.appData, 'deliveryChargeUSD'))).toFixed(2)) + String('$ (USD)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/8181b1b6e85848d856281ebd064a4fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/checkout/components/07982a54cc7833f82e48665e66739838/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod'))) {
    ___arguments.context.appData['selectedPaymentMethod'] = 'cash';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/checkout/components/a547477824787258c8d8dcb8dcd4d4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod')) == 'card')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/checkout/components/491855d87baafef88fd5bf5c33b89078/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod')) == 'card')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/checkout/components/cee8bc06d64652f8e0cdf2599aa94e47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(amount) {
	return `${Math.round(Number(amount)).toLocaleString('en-US')} (LBP)`;
})((((getObjectProperty(___arguments.context.appData, 'cartTotal')) + (getObjectProperty(___arguments.context.appData, 'deliveryChargeUSD'))) * 89500)))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/74a85e2d86c8aad8de98dcb31db84167/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Number.parseFloat(((getObjectProperty(___arguments.context.appData, 'cartTotal')) + (getObjectProperty(___arguments.context.appData, 'deliveryChargeUSD')))).toFixed(2)) + String('$ (USD)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/d6b6fb6887e80ede2fbbfc38cee451e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'selectedAddressDetails'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/fca2c54ad3f98e6f8fd2aeac0372e2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'selectedAddressType'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/a408e0882e665f68fac85a6f728816d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod')) == 'cash') {
    return 'Cash';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/abbf034ad5588f0a2592b068985816b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod')) == 'cash')

  },
  /* handler:onDisplayAssignment */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'cashImageUrl'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/checkout/components/d561a9bab398bf881df8648e93984128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a500a8e982428869581a78fbb87aa8'), 'productName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/11a80ecc10e50b486cc3ac1860d8b14a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Qty ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a500a8e982428869581a78fbb87aa8'), 'quantity')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/checkout/components/d478d5ed1f785c987004386952689468/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d3d80748a38816f8f3e862189d58a8c8'), 'image'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/checkout/components/ed08d1788dd3230c8e781a889dc8ba45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['reviewCancelled'] = true;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Cart', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/checkout/components/22ef346896e84d1860f47103ac53ea8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['reviewCancelled'] = false;
  ___arguments.context.pageData['reviewCartITems'] = (getObjectProperty(___arguments.context.appData, 'cartItems'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13f85b673128fb722f18f82831681c08', true);
  await new Promise(r => setTimeout(r, 8000 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a51889380068daa837ce32d88f08f9a8', (getObjectProperty(___arguments.context.appData, 'cartItems')));
  if ((getObjectProperty(___arguments.context.pageData, 'reviewCancelled')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13f85b673128fb722f18f82831681c08', false);
    ___arguments.context.pageData['orderDraft'] = ({ [`orderStatus`]: 'pending',[`storeId`]: (getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),[`deliverAddress`]: (getObjectProperty(___arguments.context.appData, 'selectedAddressDetails')),[`paymentMethod`]: (getObjectProperty(___arguments.context.appData, 'selectedPaymentMethod')),[`paymentStatus`]: 'unpaid',[`subtotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')),[`orderDate`]: (new Date()),[`finalTotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')) + (getObjectProperty(___arguments.context.appData, 'deliveryChargeUSD')),[`deliveryFee`]: (getObjectProperty(___arguments.context.appData, 'deliveryChargeUSD')),[`deliveryLatitude`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'latitude')),[`deliveryLongitude`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'longitude')),[`deliveryStreet`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'street')),[`deliveryBuilding`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'building')),[`deliveryFloor`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'floor')),[`deliveryApartment`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'apartment')),[`deliveryInstructions`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'instructions')),[`deliveryPhoto1`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'photo1')),[`deliveryPhoto1Description`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'photo1Description')),[`deliveryPhoto2`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'photo2')),[`deliveryPhoto2Description`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'photo2Description')),[`deliveryPhoto3`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'photo3')),[`deliveryPhoto3Description`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress')), 'photo3Description')) });
    (getObjectProperty(___arguments.context.pageData, 'orderDraft'))['storeName'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'checkoutStore')), 'storeName'));
    if ((getObjectProperty(___arguments.context.appData, 'deliveryScheduleType')) == 'later') {
      (getObjectProperty(___arguments.context.pageData, 'orderDraft'))['orderStatus'] = 'scheduled';
      (getObjectProperty(___arguments.context.pageData, 'orderDraft'))['scheduledAt'] = (getObjectProperty(___arguments.context.appData, 'selectedScheduleDate'));
    }
    ___arguments.context.pageData['savedOrder'] = (await Backendless.Data.of('Orders').save( (getObjectProperty(___arguments.context.pageData, 'orderDraft')) ));
    if (!!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'savedOrder')), 'objectId')).length) {
      await Backendless.Data.of('Orders').addRelation((getObjectProperty(___arguments.context.pageData, 'savedOrder')), 'customerUser', [(await Backendless.UserService.getCurrentUser(false))]);
      (getObjectProperty(___arguments.context.pageData, 'savedOrder'))['orderNumber'] = ([(getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),' - ',(await Backendless.Counters.addAndGet((String('orders-\'') + String(getObjectProperty(___arguments.context.pageData, 'currentCartStoreId'))), 1))].join(''));
      await Backendless.Data.of('Orders').save( (getObjectProperty(___arguments.context.pageData, 'savedOrder')) );
      var j_list = (getObjectProperty(___arguments.context.appData, 'cartItems'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        await Backendless.Data.of('OrderItems').save( ({ [`orderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'savedOrder')), 'objectId')),[`productId`]: (getObjectProperty(j, 'productId')),[`productName`]: (getObjectProperty(j, 'productName')),[`quantity`]: (getObjectProperty(j, 'quantity')),[`unitPrice`]: (getObjectProperty(j, 'price')),[`totalPrice`]: (getObjectProperty(j, 'totalPrice')),[`storeId`]: (getObjectProperty(___arguments.context.appData, 'currentCarttoreId')),[`productImage`]: (getObjectProperty(j, 'productImage')) }) );
      }
      ___arguments.context.appData['currentOrderId'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'savedOrder')), 'objectId'));
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'savedOrder')), 'orderStatus')) == 'scheduled') {
        await Backendless.Data.of('Notifications').save( ({ [`recipientId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'objectId')),[`orderId`]: (getObjectProperty(___arguments.context.appData, 'currentOrderId')),[`type`]: 'order_scheduled',[`title`]: 'Your order is scheduled',[`message`]: 'Your order Has been sceduled and will be sent to the store at your selected time.',[`isRead`]: false }) );
      } else {
        await Backendless.Data.of('Notifications').save( ({ [`recipientId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'objectId')),[`orderId`]: (getObjectProperty(___arguments.context.appData, 'currentOrderId')),[`type`]: 'order_pending',[`title`]: 'Your order is pending',[`message`]: 'Your order Has been placed and waiting for the store to accept it',[`isRead`]: false }) );
        await (async function(orderId) {
        	return Backendless.CustomServices.invoke(
        	  'OrderPushService',
        	  'sendMerchantNewOrder',
        	  String(orderId)
        	).then(function(result) {
        	  if (result && result.skipped) {
        	    return result;
        	  }
        	
        	  if (!result || !result.sent) {
        	    alert(
        	      'Merchant notification was not sent: ' +
        	      JSON.stringify(result && result.errors)
        	    );
        	  }
        	
        	  return result;
        	}).catch(function(error) {
        	  alert(
        	    'Merchant notification error: ' +
        	    (error.message || String(error))
        	  );
        	});
        })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'savedOrder')), 'objectId')));
      }
      ___arguments.context.appData['storeCarts'] = (await (async function(carts, storeId) {
      	return (Array.isArray(carts) ? carts : []).filter(
      	  cart => cart.currentCartStoreId !== storeId
      	);
      })((getObjectProperty(___arguments.context.appData, 'storeCarts')), (getObjectProperty(___arguments.context.appData, 'currentCartStoreId'))));
      localStorage.setItem((String('storeCarts_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify((getObjectProperty(___arguments.context.appData, 'storeCarts'))));
      localStorage.removeItem((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))));
      ___arguments.context.appData['cartItems'] = [];
      ___arguments.context.appData['cartCount'] = 0;
      ___arguments.context.appData['cartTotal'] = 0;
      ___arguments.context.appData['currentCartStoreId'] = '';
      ___arguments.context.appData['cartImage1'] = '';
      ___arguments.context.appData['cartImage2'] = '';
      ___arguments.context.appData['currentQuantity'] = 0;
      ___arguments.context.appData['fountCartItem'] = null;
      ___arguments.context.appData['newOrderItem'] = null;
      ___arguments.context.appData['selectedProduct'] = null;
      ___arguments.context.appData['savedCart'] = null;
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'savedOrder')), 'orderStatus')) == 'scheduled') {
        (function (message) { alert(message) })('Your order is scheduled.');
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('orderTracking', ({ [`orderId`]: (getObjectProperty(___arguments.context.appData, 'currentOrderId')) }));
      }
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.appData, 'deliveryScheduleType')) == 'later' && !!(getObjectProperty(___arguments.context.appData, 'selectedTimeSlot')).length && (getObjectProperty(___arguments.context.appData, 'selectedScheduleDate')) > (new Date()) || (getObjectProperty(___arguments.context.appData, 'deliveryScheduleType')) == 'now' && !(getObjectProperty(___arguments.context.pageData, 'checkoutScheduleOnly')) && !(getObjectProperty(___arguments.context.pageData, 'checkoutOrdiringBlocked'))))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/checkout/components/1c2c4412b3d8b49877d818d973084368/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'checkoutScheduleOnly'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'deliveryScheduleType')) == 'later' && (getObjectProperty(___arguments.context.appData, 'selectedTimeSlot')) != '') {
    return (['Scheduled for  ',(getObjectProperty(___arguments.context.appData, 'selectedScheduleDayLabel')),', ',(getObjectProperty(___arguments.context.appData, 'selectedTimeSlot'))].join(''));
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'deliveryScheduleType')) == 'later') {
      return (String('Choose an available time to continue'));
    } else {
      return '';
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/orderTracking/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.appData['activeNav'] = '';
  if (!(getObjectProperty(___arguments.context.appData, 'currentOrderId'))) {
    ___arguments.context.appData['currentOrderId'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('trackingOrderId_') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'objectId')))));
  }
  localStorage.setItem((String('trackingOrderId_') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'objectId'))), JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentOrderId'))));
  ___arguments.context.pageData['trackingOrder'] = (await Backendless.Data.of('Orders').findById((getObjectProperty(___arguments.context.appData, 'currentOrderId')), ));
  ___arguments.context.pageData['trackingStore'] = ((await Backendless.Data.of('Stores').find(Backendless.DataQueryBuilder.create().setWhereClause((['storeId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'trackingOrder')), 'storeId')),'\''].join(''))).setPageSize(1)))[0]);

  ;(function() {
    const callback = async () => {
        ___arguments.context.pageData['trackingOrder'] = (await Backendless.Data.of('Orders').findById((getObjectProperty(___arguments.context.appData, 'currentOrderId')), ));
    await (async function(markers, pageData) {
    	if (!Array.isArray(markers) || !pageData) return;
    	
    	const maps = window.google?.maps;
    	const order = pageData.trackingOrder;
    	const store = pageData.trackingStore;
    	
    	if (!maps || !order) return;
    	
    	const map = markers
    	  .map(marker => marker?.getMap?.())
    	  .find(Boolean);
    	
    	if (!map) return;
    	
    	function valid(lat, lng) {
    	  return lat != null && lng != null &&
    	    lat !== "" && lng !== "" &&
    	    Number.isFinite(Number(lat)) &&
    	    Number.isFinite(Number(lng)) &&
    	    Math.abs(Number(lat)) <= 90 &&
    	    Math.abs(Number(lng)) <= 180;
    	}
    	
    	function makeCanvas(width, height) {
    	  const canvas = document.createElement("canvas");
    	  canvas.width = width * 2;
    	  canvas.height = height * 2;
    	
    	  const ctx = canvas.getContext("2d");
    	  ctx.scale(2, 2);
    	
    	  return { canvas, ctx };
    	}
    	
    	function loadImage(url) {
    	  window.oneTrackingImageCache =
    	    window.oneTrackingImageCache || new Map();
    	
    	  const cache = window.oneTrackingImageCache;
    	
    	  if (!cache.has(url)) {
    	    const loading = new Promise((resolve, reject) => {
    	      const image = new Image();
    	      image.crossOrigin = "anonymous";
    	
    	      const timer = setTimeout(() => {
    	        image.onload = null;
    	        image.onerror = null;
    	        reject(new Error("Image load timeout"));
    	      }, 8000);
    	
    	      image.onload = () => {
    	        clearTimeout(timer);
    	        resolve(image);
    	      };
    	
    	      image.onerror = () => {
    	        clearTimeout(timer);
    	        reject(new Error("Image could not load"));
    	      };
    	
    	      image.src = url;
    	    });
    	
    	    cache.set(url, loading);
    	
    	    loading.catch(() => {
    	      if (cache.get(url) === loading) cache.delete(url);
    	    });
    	  }
    	
    	  return cache.get(url);
    	}
    	
    	// البنّان الثابتان
    	let index = 0;
    	let storeMarker = null;
    	let customerMarker = null;
    	
    	if (valid(store?.latitude, store?.longitude)) {
    	  storeMarker = markers[index++];
    	}
    	
    	if (valid(order.deliveryLatitude, order.deliveryLongitude)) {
    	  customerMarker = markers[index++];
    	}
    	
    	// بن الزبون الخمري
    	if (
    	  customerMarker?.setIcon &&
    	  customerMarker.onePinStyleKey !== "one-customer-pin-v1"
    	) {
    	  const { canvas, ctx } = makeCanvas(64, 66);
    	  const tipY = 30 + 15 * Math.SQRT2;
    	
    	  ctx.save();
    	  ctx.fillStyle = "rgba(120,45,55,0.18)";
    	  ctx.shadowColor = "rgba(120,45,55,0.18)";
    	  ctx.shadowBlur = 8;
    	  ctx.beginPath();
    	  ctx.ellipse(32, tipY + 2, 14, 4, 0, 0, Math.PI * 2);
    	  ctx.fill();
    	  ctx.restore();
    	
    	  ctx.save();
    	  ctx.translate(32, 30);
    	  ctx.rotate(-Math.PI / 4);
    	
    	  const gradient = ctx.createLinearGradient(-15, -15, 15, 15);
    	  gradient.addColorStop(0, "#E37B88");
    	  gradient.addColorStop(0.42, "#C95B69");
    	  gradient.addColorStop(0.72, "#A94452");
    	  gradient.addColorStop(1, "#873641");
    	
    	  ctx.fillStyle = gradient;
    	  ctx.shadowColor = "rgba(100,35,45,0.22)";
    	  ctx.shadowBlur = 12;
    	  ctx.shadowOffsetY = 5;
    	
    	  ctx.beginPath();
    	  ctx.moveTo(0, -15);
    	  ctx.arcTo(15, -15, 15, 0, 15);
    	  ctx.arcTo(15, 15, 0, 15, 15);
    	  ctx.lineTo(-15, 15);
    	  ctx.lineTo(-15, 0);
    	  ctx.arcTo(-15, -15, 0, -15, 15);
    	  ctx.closePath();
    	  ctx.fill();
    	  ctx.restore();
    	
    	  ctx.fillStyle = "#FFFFFF";
    	  ctx.beginPath();
    	  ctx.arc(32, 30, 4.5, 0, Math.PI * 2);
    	  ctx.fill();
    	
    	  customerMarker.setIcon({
    	    url: canvas.toDataURL("image/png"),
    	    scaledSize: new maps.Size(64, 66),
    	    anchor: new maps.Point(32, tipY)
    	  });
    	
    	  customerMarker.setZIndex(900);
    	  customerMarker.onePinStyleKey = "one-customer-pin-v1";
    	}
    	
    	// حساب المسافة واتجاه الحركة
    	function movement(from, to) {
    	  const radians = Math.PI / 180;
    	  const lat1 = from.lat * radians;
    	  const lat2 = to.lat * radians;
    	  const deltaLat = lat2 - lat1;
    	  const deltaLng = (to.lng - from.lng) * radians;
    	
    	  const a =
    	    Math.sin(deltaLat / 2) ** 2 +
    	    Math.cos(lat1) * Math.cos(lat2) *
    	    Math.sin(deltaLng / 2) ** 2;
    	
    	  const distance =
    	    6371000 * 2 *
    	    Math.atan2(
    	      Math.sqrt(Math.min(1, a)),
    	      Math.sqrt(Math.max(0, 1 - a))
    	    );
    	
    	  const y = Math.sin(deltaLng) * Math.cos(lat2);
    	  const x =
    	    Math.cos(lat1) * Math.sin(lat2) -
    	    Math.sin(lat1) * Math.cos(lat2) * Math.cos(deltaLng);
    	
    	  const heading =
    	    (Math.atan2(y, x) / radians + 360) % 360;
    	
    	  return { distance, heading };
    	}
    	
    	// الموتو المتحرّك
    	const motoUrl =
    	  "https://backendlessappcontent.com/6681E397-372B-4BCE-99A2-2E952873D446/96788808-D3EB-4CD3-812E-776A24D5DC6B/files/driver-moto.png";
    	
    	let state = window.oneTrackingMoto;
    	
    	if (
    	  state &&
    	  (state.orderId !== order.objectId || state.map !== map)
    	) {
    	  state.marker.setMap(null);
    	  window.oneTrackingMoto = null;
    	  state = null;
    	}
    	
    	const showDriver =
    	  order.orderStatus === "onTheWay" &&
    	  order.driverId &&
    	  valid(order.driverLatitude, order.driverLongitude);
    	
    	if (!showDriver) {
    	  if (state) {
    	    state.marker.setMap(null);
    	    window.oneTrackingMoto = null;
    	  }
    	} else {
    	  const position = {
    	    lat: Number(order.driverLatitude),
    	    lng: Number(order.driverLongitude)
    	  };
    	
    	  if (!state) {
    	    state = {
    	      orderId: order.objectId,
    	      map,
    	      heading: 90,
    	      directionPoint: position,
    	      marker: new maps.Marker({
    	        map,
    	        position,
    	        title: "Driver",
    	        zIndex: 1100,
    	        icon: {
    	          url: motoUrl,
    	          scaledSize: new maps.Size(44, 44),
    	          anchor: new maps.Point(22, 22)
    	        }
    	      })
    	    };
    	
    	    window.oneTrackingMoto = state;
    	  }
    	
    	  // تجهيز الحالة إذا كانت من الكود السابق
    	  if (!Number.isFinite(state.heading)) state.heading = 90;
    	  if (!state.directionPoint) state.directionPoint = position;
    	
    	  const change = movement(state.directionPoint, position);
    	
    	  // تجاهل الحركة الصغيرة لتخفيف لفّات GPS وهو واقف
    	  if (change.distance >= 8) {
    	    state.heading = change.heading;
    	    state.directionPoint = position;
    	  }
    	
    	  state.marker.setPosition(position);
    	
    	  function applyMotoRotation() {
    	    if (
    	      !state.image ||
    	      window.oneTrackingMoto !== state ||
    	      state.marker.getMap() !== map
    	    ) return;
    	
    	    // صورة الموتو الأصلية متجهة لليمين
    	    const mapHeading = Number(map.getHeading?.()) || 0;
    	    const angle =
    	      Math.round(state.heading - mapHeading - 90);
    	
    	    if (state.renderedAngle === angle) return;
    	
    	    const { canvas, ctx } = makeCanvas(64, 64);
    	    ctx.translate(32, 32);
    	    ctx.rotate(angle * Math.PI / 180);
    	
    	    const scale = Math.min(
    	      44 / state.image.naturalWidth,
    	      44 / state.image.naturalHeight
    	    );
    	
    	    const width = state.image.naturalWidth * scale;
    	    const height = state.image.naturalHeight * scale;
    	
    	    ctx.drawImage(
    	      state.image,
    	      -width / 2,
    	      -height / 2,
    	      width,
    	      height
    	    );
    	
    	    state.marker.setIcon({
    	      url: canvas.toDataURL("image/png"),
    	      scaledSize: new maps.Size(64, 64),
    	      anchor: new maps.Point(32, 32)
    	    });
    	
    	    state.renderedAngle = angle;
    	  }
    	
    	  if (state.image) {
    	    try {
    	      applyMotoRotation();
    	    } catch (error) {
    	      console.warn("Moto rotation:", error.message);
    	    }
    	  } else if (!state.imageLoading) {
    	    state.imageLoading = true;
    	
    	    loadImage(motoUrl)
    	      .then(image => {
    	        if (window.oneTrackingMoto !== state) return;
    	        state.image = image;
    	        applyMotoRotation();
    	      })
    	      .catch(error => {
    	        console.warn("Moto rotation:", error.message);
    	      })
    	      .finally(() => {
    	        state.imageLoading = false;
    	      });
    	  }
    	}
    	
    	// دايرة الستور
    	if (!storeMarker?.setIcon) return;
    	
    	const logoUrl =
    	  typeof store?.logo === "string" ? store.logo.trim() : "";
    	
    	const styleKey = "one-store-circle-v1:" + logoUrl;
    	
    	if (
    	  storeMarker.onePinStyleKey === styleKey ||
    	  storeMarker.onePinLoadingKey === styleKey
    	) return;
    	
    	storeMarker.onePinLoadingKey = styleKey;
    	
    	function drawStoreCircle(image) {
    	  const { canvas, ctx } = makeCanvas(56, 56);
    	
    	  ctx.save();
    	  ctx.shadowColor = "rgba(100,35,45,0.25)";
    	  ctx.shadowBlur = 8;
    	  ctx.shadowOffsetY = 3;
    	  ctx.fillStyle = "#FFFFFF";
    	  ctx.beginPath();
    	  ctx.arc(28, 28, 21, 0, Math.PI * 2);
    	  ctx.fill();
    	  ctx.restore();
    	
    	  if (image) {
    	    ctx.save();
    	    ctx.beginPath();
    	    ctx.arc(28, 28, 18, 0, Math.PI * 2);
    	    ctx.clip();
    	
    	    const scale = Math.min(
    	      36 / image.naturalWidth,
    	      36 / image.naturalHeight
    	    );
    	
    	    const width = image.naturalWidth * scale;
    	    const height = image.naturalHeight * scale;
    	
    	    ctx.drawImage(
    	      image,
    	      28 - width / 2,
    	      28 - height / 2,
    	      width,
    	      height
    	    );
    	
    	    ctx.restore();
    	  } else {
    	    ctx.fillStyle = "#873641";
    	    ctx.font = "bold 12px Arial";
    	    ctx.textAlign = "center";
    	    ctx.textBaseline = "middle";
    	    ctx.fillText(
    	      String(store?.name || store?.storeName || "Store").slice(0, 6),
    	      28,
    	      28
    	    );
    	  }
    	
    	  ctx.strokeStyle = "#C95B69";
    	  ctx.lineWidth = 2;
    	  ctx.beginPath();
    	  ctx.arc(28, 28, 21, 0, Math.PI * 2);
    	  ctx.stroke();
    	
    	  return canvas.toDataURL("image/png");
    	}
    	
    	storeMarker.setIcon({
    	  url: drawStoreCircle(null),
    	  scaledSize: new maps.Size(56, 56),
    	  anchor: new maps.Point(28, 28)
    	});
    	
    	storeMarker.setZIndex(1000);
    	
    	try {
    	  if (logoUrl) {
    	    const image = await loadImage(logoUrl);
    	
    	    const currentLogo =
    	      typeof pageData.trackingStore?.logo === "string"
    	        ? pageData.trackingStore.logo.trim()
    	        : "";
    	
    	    if (
    	      pageData.trackingOrder?.objectId !== order.objectId ||
    	      currentLogo !== logoUrl ||
    	      storeMarker.getMap?.() !== map
    	    ) return;
    	
    	    storeMarker.setIcon({
    	      url: drawStoreCircle(image),
    	      scaledSize: new maps.Size(56, 56),
    	      anchor: new maps.Point(28, 28)
    	    });
    	  }
    	
    	  storeMarker.onePinStyleKey = styleKey;
    	} catch (error) {
    	  console.warn("Store logo:", error.message);
    	  storeMarker.onePinStyleKey = styleKey;
    	} finally {
    	  if (storeMarker.onePinLoadingKey === styleKey) {
    	    storeMarker.onePinLoadingKey = null;
    	  }
    	}
    })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).map.markers })('230860c87798fce8594861aa3057e871')), ___arguments.context.pageData);
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'trackingOrder')), 'orderStatus')) == 'completed') {
      stopSetTimeout('trackingOrderRefresh');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
    }

    };

    const timerId = 'trackingOrderRefresh';
    const timerDelay = 3000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/orderTracking/components/47e96d98c8f89b4874e8037898572788/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order) {
	if (!order) return ["tracking-step"];
	
	if (order.acceptedAt || [
	  "accepted",
	  "preparing",
	  "driverAccepted",
	  "driverAtStore",
	  "onTheWay",
	  "completed"
	].includes(order.orderStatus)) {
	  return ["tracking-step", "is-done"];
	}
	
	if (order.orderStatus === "pending") {
	  return ["tracking-step", "is-active"];
	}
	
	return ["tracking-step"];
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder'))))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/orderTracking/components/94d800287a1dd5613f4874b81818ea78/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order) {
	if (!order) return ["tracking-step"];
	
	if (order.acceptedAt || [
	  "accepted",
	  "preparing",
	  "driverAccepted",
	  "driverAtStore",
	  "onTheWay",
	  "completed"
	].includes(order.orderStatus)) {
	  return ["tracking-step", "is-done"];
	}
	
	return ["tracking-step"];
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder'))))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/orderTracking/components/17c56c22ab78a238b7db4012ffd86308/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order) {
	if (!order) return ["tracking-step"];
	
	if (
	  order.readyAt ||
	  ["onTheWay", "completed"].includes(order.orderStatus)
	) {
	  return ["tracking-step", "is-done"];
	}
	
	if ([
	  "accepted",
	  "preparing",
	  "driverAccepted",
	  "driverAtStore"
	].includes(order.orderStatus)) {
	  return ["tracking-step", "is-active"];
	}
	
	return ["tracking-step"];
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder'))))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/orderTracking/components/40d83b5bc99f7f68c448ff14d0a852c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order) {
	return !!order && [
	  "driverAccepted",
	  "driverAtStore",
	  "onTheWay",
	  "completed"
	].includes(order.orderStatus);
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder'))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order) {
	if (!order) return ["tracking-step"];
	
	if ([
	  "driverAtStore",
	  "onTheWay",
	  "completed"
	].includes(order.orderStatus)) {
	  return ["tracking-step", "is-done"];
	}
	
	if (order.orderStatus === "driverAccepted") {
	  return ["tracking-step", "is-active"];
	}
	
	return ["tracking-step"];
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder'))))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/orderTracking/components/e4385c88ebfa636d037ac588b6954ae8/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order) {
	if (!order) return ["tracking-step"];
	
	if ([
	  "driverAccepted",
	  "driverAtStore",
	  "onTheWay",
	  "completed"
	].includes(order.orderStatus)) {
	  return ["tracking-step", "is-done"];
	}
	
	return ["tracking-step"];
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder'))))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/orderTracking/components/d3c8bf4875680e585056cb9834e62838/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order) {
	if (!order) return ["tracking-step"];
	
	if (["onTheWay", "completed"].includes(order.orderStatus)) {
	  return ["tracking-step", "is-done"];
	}
	
	if (order.readyAt) {
	  return ["tracking-step", "is-active"];
	}
	
	return ["tracking-step"];
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder'))))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/orderTracking/components/1bf88d08b3187aa319062098c418787c/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order) {
	if (!order) return ["tracking-step"];
	
	if (order.orderStatus === "completed") {
	  return ["tracking-step", "is-done"];
	}
	
	if (order.orderStatus === "onTheWay") {
	  return ["tracking-step", "is-active"];
	}
	
	return ["tracking-step"];
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder'))))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/orderTracking/components/bcb8b0d50eb8b4581ed8d8380de8f087/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order) {
	if (!order) return ["tracking-step"];
	
	return order.orderStatus === "completed"
	  ? ["tracking-step", "is-done"]
	  : ["tracking-step"];
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder'))))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/orderTracking/components/e358b2d91079740b36424188915d7286/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order) {
	const classes = ["tracking-step"];
	
	if (!order) return classes;
	
	if (order.orderStatus === "completed") {
	  return [...classes, "is-done"];
	}
	
	if (order.orderStatus !== "onTheWay") return classes;
	
	const values = [
	  order.driverLatitude,
	  order.driverLongitude,
	  order.deliveryLatitude,
	  order.deliveryLongitude
	];
	
	if (values.some(v => v == null || v === "")) return classes;
	
	const [lat1, lon1, lat2, lon2] = values.map(Number);
	
	if (![lat1, lon1, lat2, lon2].every(Number.isFinite)) {
	  return classes;
	}
	
	if (
	  Math.abs(lat1) > 90 || Math.abs(lat2) > 90 ||
	  Math.abs(lon1) > 180 || Math.abs(lon2) > 180
	) return classes;
	
	const  updatedAt = order.driverLocationUpdatedAt;
	if (!updatedAt) return classes;
	
	const age = Date.now() - new Date(updatedAt).getTime();
	
	if (!Number.isFinite(age) || age < 0 || age > 60000) {
	  return classes;
	}
	
	const rad = degrees => degrees * Math.PI / 180;
	const dLat = rad(lat2 - lat1);
	const dLon = rad(lon2 - lon1);
	
	const a =
	  Math.sin(dLat / 2) ** 2 +
	  Math.cos(rad(lat1)) * Math.cos(rad(lat2)) *
	  Math.sin(dLon / 2) ** 2;
	
	const distance =
	  6371000 * 2 * Math.asin(Math.sqrt(Math.min(1, a)));
	
	return distance <= 500
	  ? [...classes, "is-active"]
	  : classes;
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder'))))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/orderTracking/components/230860c87798fce8594861aa3057e871/bundle.js', [], () => ({
  /* content */
  /* handler:onMapCenterAssignment */
  async ['onMapCenterAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order, store) {
	function point(lat, lng) {
	  if (
	    lat == null || lng == null ||
	    lat === "" || lng === ""
	  ) return null;
	
	  lat = Number(lat);
	  lng = Number(lng);
	
	  if (
	    !Number.isFinite(lat) ||
	    !Number.isFinite(lng) ||
	    Math.abs(lat) > 90 ||
	    Math.abs(lng) > 180
	  ) return null;
	
	  return { lat, lng };
	}
	
	const destination = point(
	  order?.deliveryLatitude,
	  order?.deliveryLongitude
	);
	
	const pickup = point(
	  store?.latitude,
	  store?.longitude
	);
	
	const driver =
	  order?.orderStatus === "onTheWay" && order?.driverId
	    ? point(order.driverLatitude, order.driverLongitude)
	    : null;
	
	// بعد Pick Up: المركز بيتبع الدرايفر
	if (driver) return driver;
	
	// قبل Pick Up: المركز على الستور
	return pickup || destination || {
	  lat: 33.8938,
	  lng: 35.5018
	};
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder')), (getObjectProperty(___arguments.context.pageData, 'trackingStore'))))

  },
  /* handler:onMapCenterAssignment */
  /* handler:onPointsAssignment */
  async ['onPointsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order, store, pageData) {
	function valid(lat, lng) {
	  return lat != null && lng != null &&
	    lat !== "" && lng !== "" &&
	    Number.isFinite(Number(lat)) &&
	    Number.isFinite(Number(lng)) &&
	    Math.abs(Number(lat)) <= 90 &&
	    Math.abs(Number(lng)) <= 180;
	}
	
	const points = [];
	
	if (valid(store?.latitude, store?.longitude)) {
	  points.push({
	    lat: Number(store.latitude),
	    lng: Number(store.longitude)
	  });
	}
	
	if (valid(order?.deliveryLatitude, order?.deliveryLongitude)) {
	  points.push({
	    lat: Number(order.deliveryLatitude),
	    lng: Number(order.deliveryLongitude)
	  });
	}
	
	// نفس اللائحة طالما الستور والعنوان ما تغيّروا
	const key = JSON.stringify([order?.objectId, points]);
	
	if (window.oneTrackingPoints?.key !== key) {
	  window.oneTrackingPoints = { key, points };
	}
	
	return window.oneTrackingPoints.points;
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder')), (getObjectProperty(___arguments.context.pageData, 'trackingStore')), ___arguments.context.pageData))

  },
  /* handler:onPointsAssignment */
  /* handler:onMapZoomAssignment */
  async ['onMapZoomAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order, store) {
	function point(lat, lng) {
	  if (
	    lat == null || lng == null ||
	    lat === "" || lng === ""
	  ) return null;
	
	  lat = Number(lat);
	  lng = Number(lng);
	
	  if (
	    !Number.isFinite(lat) ||
	    !Number.isFinite(lng) ||
	    Math.abs(lat) > 90 ||
	    Math.abs(lng) > 180
	  ) return null;
	
	  return { lat, lng };
	}
	
	const destination = point(
	  order?.deliveryLatitude,
	  order?.deliveryLongitude
	);
	
	const pickup = point(
	  store?.latitude,
	  store?.longitude
	);
	
	const driver =
	  order?.orderStatus === "onTheWay" && order?.driverId
	    ? point(order.driverLatitude, order.driverLongitude)
	    : null;
	
	const start = driver || pickup;
	
	if (!start || !destination) return 16;
	
	// المسافة بالمتر
	const radians = Math.PI / 180;
	const lat1 = start.lat * radians;
	const lat2 = destination.lat * radians;
	const deltaLat = lat2 - lat1;
	const deltaLng =
	  (destination.lng - start.lng) * radians;
	
	const a =
	  Math.sin(deltaLat / 2) ** 2 +
	  Math.cos(lat1) * Math.cos(lat2) *
	  Math.sin(deltaLng / 2) ** 2;
	
	const distance =
	  6371000 * 2 * Math.atan2(
	    Math.sqrt(Math.min(1, a)),
	    Math.sqrt(Math.max(0, 1 - a))
	  );
	
	// بعيد: زوم 16
	// عند 500 متر: زوم 17
	// عند 125 متر أو أقل: زوم 18
	const zoom =
	  17 - Math.log2(Math.max(distance, 1) / 500) / 2;
	
	return Math.max(16, Math.min(18, zoom));
})((getObjectProperty(___arguments.context.pageData, 'trackingOrder')), (getObjectProperty(___arguments.context.pageData, 'trackingStore'))))

  },
  /* handler:onMapZoomAssignment */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/3d98b902dd88ede40cc6fb2dea481658/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'userInitial'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ProfilePage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/root/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['userName'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'fullName'));
  ___arguments.context.appData['userInitial'] = ((getObjectProperty(___arguments.context.appData, 'userName')).slice(0, 2));
  if (!!(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')).length) {
    ___arguments.context.appData['showProfileIcon'] = false;
    ___arguments.context.appData['showProfileInitial'] = true;
  } else {
    ___arguments.context.appData['showProfileIcon'] = true;
    ___arguments.context.appData['showProfileInitial'] = false;
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/a76e2aa8250870bdb278d801f7560468/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ProfilePage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/90d845e86a7721c55c38b3289eec4958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('OrdersPage', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'activeNav')) == 'Orders') {
    return ({ [`color`]: '#914343' });
  } else {
    return ({ [`color`]: '#8A8A8A' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/3518c3e8673acc9888f99224f1bf2e48/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'activeNav')) == 'Home') {
    return ({ [`color`]: '#914343' });
  } else {
    return ({ [`color`]: '#8A8A8A' });
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/afb434c8ca88b828cf283f38c8d3e048/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'activeNav')) == 'Home') {
    ___arguments.context.appData['color'] = '#914343';
  } else {
    ___arguments.context.appData['color'] = '#8A8A8A';
  }

  return ({ [`color`]: (getObjectProperty(___arguments.context.appData, 'color')) })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/8e27d0e438b326feccd429b53f185081/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Store', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'activeNav')) == 'Store') {
    return ({ [`color`]: '#914343' });
  } else {
    return ({ [`color`]: '#8a8a8a' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/e422d829c488e888f7ec0e259d79f0b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Store', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'activeNav')) == 'Store') {
    return ({ [`color`]: '#914343' });
  } else {
    return ({ [`color`]: '#8a8a8a' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/f298e9bc79c6faf999786cb68b026088/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('OrdersPage', undefined);

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'activeNav')) == 'Orders') {
    return ({ [`color`]: '#914343' });
  } else {
    return ({ [`color`]: '#8a8a8a' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/7353f5f85b58794c1c58c86897caaa28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.appData, 'cartCount')) + String(' items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/4adb0608d198911820b8a1c4aded9b58/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('$') + String(getObjectProperty(___arguments.context.appData, 'cartTotal')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/6f482818f8dafadd90c121b94cc1a937/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'cartImage1'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'cartCount')) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/095cc8a8d118b0b468c8663587d83028/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'cartImage2'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'cartCount')) > 1)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/e4f8c608a2e8d988eb9757eb2c28717c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Cart', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./layouts/MainNavigationLayout/components/eca871c220e2c9e8a2d46a6ac41bf696/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'cartCount')) > 0 && (getObjectProperty(___arguments.context.appData, 'isStorePage')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_f8691bce4451a3662441ae67c0e454f3/logic/f62e37b895187c382628c57865780bb8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['stores'] = (await Backendless.Data.of('Stores').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f62e37b895187c382628c57865780bb8', (await Backendless.Data.of('Orders').find(Backendless.DataQueryBuilder.create().setWhereClause((['customerUser.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'objectId')),'\' AND orderStatus IN (\'pending\',\'accepted\',\'preparing\',\'driverAccepted\',\'driverAtStore\',\'onTheWay\',\'completed\')'].join(''))).setSortBy('created DESC').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_f8691bce4451a3662441ae67c0e454f3/logic/b7387c5365fbc3a49c89b21d65d84028/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order, stores) {
	if (!order?.storeId || !Array.isArray(stores)) {
	  return "";
	}
	
	const store = stores.find(
	  item => item.storeId === order.storeId
	);
	
	return store?.logo || "";
})(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), (getObjectProperty(___arguments.context.pageData, 'stores'))))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./components/reusable/r_f8691bce4451a3662441ae67c0e454f3/logic/1cf8e06952a8635896ceffbc0278dde8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order, stores) {
	if (!order) return "";
	
	const store = Array.isArray(stores)
	  ? stores.find(item => item.storeId === order.storeId)
	  : null;
	
	return store?.storeName || order.storeName || "";
})(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), (getObjectProperty(___arguments.context.pageData, 'stores'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_f8691bce4451a3662441ae67c0e454f3/logic/cb88acf7f68afc680d689e588f382966/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await (async function(order) {
	if (!order) return "";
	
	const completed = order.orderStatus === "completed";
	const value = completed
	  ? (order.deliveredAt || order.completedAt)
	  : (order.created || order.orderDate);
	
	const label = completed ? "Delivered on" : "Pending";
	
	if (value == null || value === "") return label;
	
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return label;
	
	const day = date.toLocaleDateString("en-US", {
	  timeZone: "Asia/Beirut",
	  weekday: "long",
	  month: "long",
	  day: "numeric"
	});
	
	const time = date.toLocaleTimeString("en-US", {
	  timeZone: "Asia/Beirut",
	  hour: "numeric",
	  minute: "2-digit",
	  hour12: true
	});
	
	return `${label} · ${day} · ${time}`;
})(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_f8691bce4451a3662441ae67c0e454f3/logic/410808e8dda84338844890a88cffa191/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedOrderDetailsId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'objectId'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('OrderDetails', ___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_f8691bce4451a3662441ae67c0e454f3/logic/c428be1724a8ed3816e3207d9fa875c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((await Backendless.Data.of('OrderItems').find(Backendless.DataQueryBuilder.create().setWhereClause((['orderId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'objectId')),' \''].join(''))).setPageSize(10)))[0]), 'quantity'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_f8691bce4451a3662441ae67c0e454f3/logic/4a3845f8ef7edb9a643a1838e3f80d88/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((await Backendless.Data.of('OrderItems').find(Backendless.DataQueryBuilder.create().setWhereClause((['orderId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'objectId')),' \''].join(''))).setPageSize(10)))[0]), 'productName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_f8691bce4451a3662441ae67c0e454f3/logic/28f8621a0fe8e663cfa972b8e33a4c3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await (async function(order) {
	if (order?.finalTotal == null || order.finalTotal === "") return "";
	
	const total = Number(order.finalTotal);
	if (!Number.isFinite(total)) return "";
	
	return (total * 89500).toLocaleString("en-US", {
	  minimumFractionDigits: 0,
	  maximumFractionDigits: 0
	}) + " LBP";
})(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_f8691bce4451a3662441ae67c0e454f3/logic/ff9f932935e8d488adb3552a361c7177/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Number.parseFloat((getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'finalTotal'))).toFixed(2)) + String(' USD'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_f8691bce4451a3662441ae67c0e454f3/logic/15e8636878389518e637c9f86c9184b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'orderStatus')) != 'completed')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['currentOrderId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'objectId'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('orderTracking', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9453a3e759afafae451ed1647c072c18/logic/f62e37b895187c382628c57865780bb8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['stores'] = (await Backendless.Data.of('Stores').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f62e37b895187c382628c57865780bb8', (await Backendless.Data.of('Orders').find(Backendless.DataQueryBuilder.create().setWhereClause((['customerUser.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'objectId')),'\' AND objectId = \'',(getObjectProperty(___arguments.context.appData, 'selectedOrderDetailsId')),'\''].join(''))).setSortBy('created DESC').setPageSize(1))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_9453a3e759afafae451ed1647c072c18/logic/b7387c5365fbc3a49c89b21d65d84028/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order, stores) {
	if (!order?.storeId || !Array.isArray(stores)) {
	  return "";
	}
	
	const store = stores.find(
	  item => item.storeId === order.storeId
	);
	
	return store?.logo || "";
})(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), (getObjectProperty(___arguments.context.pageData, 'stores'))))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./components/reusable/r_9453a3e759afafae451ed1647c072c18/logic/1cf8e06952a8635896ceffbc0278dde8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(order, stores) {
	if (!order) return "";
	
	const store = Array.isArray(stores)
	  ? stores.find(item => item.storeId === order.storeId)
	  : null;
	
	return store?.storeName || order.storeName || "";
})(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), (getObjectProperty(___arguments.context.pageData, 'stores'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_9453a3e759afafae451ed1647c072c18/logic/cb88acf7f68afc680d689e588f382966/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await (async function(order) {
	if (!order) return "";
	
	const completed = order.orderStatus === "completed";
	const value = completed
	  ? (order.deliveredAt || order.completedAt)
	  : (order.created || order.orderDate);
	
	const label = completed ? "Delivered on" : "Pending";
	
	if (value == null || value === "") return label;
	
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return label;
	
	const day = date.toLocaleDateString("en-US", {
	  timeZone: "Asia/Beirut",
	  weekday: "long",
	  month: "long",
	  day: "numeric"
	});
	
	const time = date.toLocaleTimeString("en-US", {
	  timeZone: "Asia/Beirut",
	  hour: "numeric",
	  minute: "2-digit",
	  hour12: true
	});
	
	return `${label} · ${day} · ${time}`;
})(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_9453a3e759afafae451ed1647c072c18/logic/c428be1724a8ed3816e3207d9fa875c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((await Backendless.Data.of('OrderItems').find(Backendless.DataQueryBuilder.create().setWhereClause((['orderId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'objectId')),' \''].join(''))).setPageSize(10)))[0]), 'quantity'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_9453a3e759afafae451ed1647c072c18/logic/4a3845f8ef7edb9a643a1838e3f80d88/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((await Backendless.Data.of('OrderItems').find(Backendless.DataQueryBuilder.create().setWhereClause((['orderId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'objectId')),' \''].join(''))).setPageSize(10)))[0]), 'productName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_9453a3e759afafae451ed1647c072c18/logic/28f8621a0fe8e663cfa972b8e33a4c3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await (async function(order) {
	if (order?.finalTotal == null || order.finalTotal === "") return "";
	
	const total = Number(order.finalTotal);
	if (!Number.isFinite(total)) return "";
	
	return (total * 89500).toLocaleString("en-US", {
	  minimumFractionDigits: 0,
	  maximumFractionDigits: 0
	}) + " LBP";
})(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_9453a3e759afafae451ed1647c072c18/logic/ff9f932935e8d488adb3552a361c7177/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Number.parseFloat((getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'finalTotal'))).toFixed(2)) + String(' USD'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_9453a3e759afafae451ed1647c072c18/logic/15e8636878389518e637c9f86c9184b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'orderStatus')) == 'completed')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['reorderItems'] = (await Backendless.Data.of('OrderItems').find(Backendless.DataQueryBuilder.create().setWhereClause((['orderId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'objectId')),'\''].join(''))).setPageSize(100)));
  ___arguments.context.appData['cartItems'] = (await (async function(items, order) {
  	return items.map(item => {
  	  const quantity = Number(item.quantity);
  	  const unitPrice = item.unitPrice != null && item.unitPrice !== ""
  	    ? Number(item.unitPrice)
  	    : Number(item.totalPrice) / quantity;
  	
  	  return {
  	    productId: item.productId,
  	    productName: item.productName,
  	    quantity,
  	    unitPrice,
  	    storeId: order.storeId,
  	    totalPrice: unitPrice * quantity,
  	    image: item.productImage || ""
  	  };
  	});
  })((getObjectProperty(___arguments.context.pageData, 'reorderItems')), ___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318')));
  ___arguments.context.appData['cartCount'] = (await (async function(items) {
  	return items.reduce(
  	  (count, item) => count + Number(item.quantity),
  	  0
  	);
  })((getObjectProperty(___arguments.context.appData, 'cartItems'))));
  ___arguments.context.appData['cartTotal'] = (await (async function(items) {
  	return items.reduce(
  	  (total, item) => total + Number(item.totalPrice),
  	  0
  	);
  })((getObjectProperty(___arguments.context.appData, 'cartItems'))));
  ___arguments.context.appData['currentCartStoreId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('456899b840682da836cf66c1e4dc3318'), 'storeId'));
  ___arguments.context.appData['cartImage1'] = (await (async function(items) {
  	return items.length ? items[items.length - 1].image || "" : "";
  })((getObjectProperty(___arguments.context.appData, 'cartItems'))));
  ___arguments.context.appData['cartImage2'] = (await (async function(items) {
  	return items.length > 1
  	  ? items[items.length - 2].image || ""
  	  : "";
  })((getObjectProperty(___arguments.context.appData, 'cartItems'))));
  localStorage.setItem((String('_cart') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify(({ [`cartItems`]: (getObjectProperty(___arguments.context.appData, 'cartItems')),[`cartCount`]: (getObjectProperty(___arguments.context.appData, 'cartCount')),[`cartTotal`]: (getObjectProperty(___arguments.context.appData, 'cartTotal')),[`currentCartStoreId`]: (getObjectProperty(___arguments.context.appData, 'currentCartStoreId')),[`cartImage1`]: (getObjectProperty(___arguments.context.appData, 'cartImage1')),[`cartImage2`]: (getObjectProperty(___arguments.context.appData, 'cartImage2')) })));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Cart', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_987c171ee7f2bbc870627125e87c7e52/logic/45a86258a9955d58b62bb748cb51cf58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['editingAddress'] = null;
  ___arguments.context.appData['editingAddressId'] = '';
  ___arguments.context.appData['AddressPhoto1'] = '';
  ___arguments.context.appData['AddressPhoto2'] = '';
  ___arguments.context.appData['AddressPhoto3'] = '';
  ___arguments.context.appData['photosCount'] = 0;
  ___arguments.context.appData['DraftAddressName'] = '';
  ___arguments.context.appData['DraftStreet'] = '';
  ___arguments.context.appData['DraftBuilding'] = '';
  ___arguments.context.appData['DraftApartment'] = '';
  ___arguments.context.appData['DraftFloor'] = '';
  ___arguments.context.appData['DraftInstructions'] = '';
  ___arguments.context.appData['DraftAddressPhoto1'] = '';
  ___arguments.context.appData['DraftAddressPhoto2'] = '';
  ___arguments.context.appData['DraftAddressPhoto3'] = '';
  ___arguments.context.appData['DraftPhoto1Description'] = '';
  ___arguments.context.appData['DraftPhoto2Description'] = '';
  ___arguments.context.appData['DraftPhoto3Description'] = '';
  ___arguments.context.appData['DraftAddressType'] = '';
  ___arguments.context.appData['PhotoDescriptionChanged'] = false;
  ___arguments.context.appData['DeletePhotoNumber'] = 0;
  ___arguments.context.appData['photosCount'] = 0;
  ___arguments.context.appData['HasAddressPhoto'] = false;
  ___arguments.context.appData['addressLocationConfirmed'] = false;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DeliveringTo', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_987c171ee7f2bbc870627125e87c7e52/logic/39a6dad806afedf82b0e0ef8f1982d9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'savedAddresses'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_987c171ee7f2bbc870627125e87c7e52/logic/23787aebbc58c448c2f8ff982f75fd72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedDeliveryAddress'] = ___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99');
  ___arguments.context.appData['selectedDeliveryAddressName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99'), 'addressType'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63dd5c086604d4ddf9cf62786f98f628'))['display'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_987c171ee7f2bbc870627125e87c7e52/logic/4c31dff86a395ae327a74718c36599f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedDeliveryAddress'] = ___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99');
  ___arguments.context.appData['selectedDeliveryAddressName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99'), 'addressName'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63dd5c086604d4ddf9cf62786f98f628'))['display'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_987c171ee7f2bbc870627125e87c7e52/logic/c44826285358e9f892e561eff7e88c69/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99'), 'addressName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_987c171ee7f2bbc870627125e87c7e52/logic/5928c2734dcf22c805b16e86298d1466/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99'), 'addressType')),', ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99'), 'street')),', ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99'), 'building')),', ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99'), 'floor')),', ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99'), 'apartment'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_987c171ee7f2bbc870627125e87c7e52/logic/8a3f7cc848f897763c583798274880de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['editingAddress'] = ___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99');
  ___arguments.context.appData['editingAddressId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99'), 'objectId'));
  ___arguments.context.appData['DraftAddressType'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea181680158eff856781de87ef8db99'), 'addressType'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DeliveringTo', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_987c171ee7f2bbc870627125e87c7e52/logic/63dd5c086604d4ddf9cf62786f98f628/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var x, OpenPopup;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['savedAddresses'] = (await Backendless.Data.of('Addresses').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')),' \''].join(''))).setPageSize(10)));

  },
  /* handler:onMounted */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'showLocationPopup'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_987c171ee7f2bbc870627125e87c7e52/logic/8ea181680158eff856781de87ef8db99/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['selectedDeliveryAddress'] = ___arguments.context.dataModel;
  localStorage.setItem((String('_selectedAddress') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))), JSON.stringify((getObjectProperty(___arguments.context.appData, 'selectedDeliveryAddress'))));
  ___arguments.context.appData['selectedAddressType'] = (getObjectProperty(___arguments.context.dataModel, 'addressType'));
  ___arguments.context.appData['selectedAddressDetails'] = ([(getObjectProperty(___arguments.context.dataModel, 'addressName')),' - ',(getObjectProperty(___arguments.context.dataModel, 'street')),' - ',(getObjectProperty(___arguments.context.dataModel, 'building')),' - ',(getObjectProperty(___arguments.context.dataModel, 'floor'))].join(''));
  ___arguments.context.appData['selectedLatitude'] = (getObjectProperty(___arguments.context.dataModel, 'latitude'));
  ___arguments.context.appData['selectedLongitude'] = (getObjectProperty(___arguments.context.dataModel, 'longitude'));
  ___arguments.context.appData['deliveryChargeUSD'] = null;
  ___arguments.context.appData['deliveryDistanceMeters'] = (await (async function(storeLat, storeLng, addressLat, addressLng) {
  	const origin = {
  	  lat: Number(storeLat),
  	  lng: Number(storeLng)
  	};
  	
  	const destination = {
  	  lat: Number(addressLat),
  	  lng: Number(addressLng)
  	};
  	
  	if (
  	  !Number.isFinite(origin.lat) ||
  	  !Number.isFinite(origin.lng) ||
  	  !Number.isFinite(destination.lat) ||
  	  !Number.isFinite(destination.lng)
  	) {
  	  return `storeLat=${storeLat}, storeLng=${storeLng}, addressLat=${addressLat}, addressLng=${addressLng}`;
  	}
  	
  	return (async () => {
  	  try {
  	    const { Route } = await google.maps.importLibrary('routes');
  	
  	    const { routes } = await Route.computeRoutes({
  	      origin,
  	      destination,
  	      travelMode: 'DRIVING',
  	      fields: ['distanceMeters']
  	    });
  	
  	    return routes?.[0]?.distanceMeters ?? 'NO_ROUTE';
  	  } catch (error) {
  	    console.error('Delivery route error:', error);
  	    return 'ROUTE_ERROR: ' + (error?.message || String(error));
  	  }
  	})();
  })((getObjectProperty(___arguments.context.appData, 'checkoutStoreLatitude')), (getObjectProperty(___arguments.context.appData, 'checkoutStoreLongitude')), (getObjectProperty(___arguments.context.appData, 'selectedLatitude')), (getObjectProperty(___arguments.context.appData, 'selectedLongitude'))));
  if ((getObjectProperty(___arguments.context.appData, 'deliveryDistanceMeters')) != null) {
    ___arguments.context.appData['deliveryChargeUSD'] = 1.5;
    if ((getObjectProperty(___arguments.context.appData, 'deliveryDistanceMeters')) > 3000) {
      ___arguments.context.appData['deliveryChargeUSD'] = (Math.ceil(((getObjectProperty(___arguments.context.appData, 'deliveryDistanceMeters')) - 3000) / 1000) * 0.5 + 1.5);
    }
  }
  ___arguments.context.appData['showSelectedMap'] = true;
  ___arguments.context.appData['showLocationPopup'] = false;
  ___arguments.context.appData['refreshCheckoutMap'] = true;
  await new Promise(r => setTimeout(r, 500 || 0));
  ___arguments.context.appData['refreshCheckoutMap'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63dd5c086604d4ddf9cf62786f98f628', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_987c171ee7f2bbc870627125e87c7e52/logic/df368ec5aef9c1cf12bd3fb868d392bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['showLocationPopup'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63dd5c086604d4ddf9cf62786f98f628', false);

  },
  /* handler:onClick */
  /* content */
}))

